import { ContentState, convertToRaw, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
  adminReqConfig,
  api,
  baseURL,
  superAdminReqConfig,
} from "../../include/api";
import { ADD, EDIT, ERROR, SUCCESS, VIEW } from "../../include/constant";
import {
  getAdmin,
  isEmptyObj,
  preventArrow,
  preventClick,
  preventWheel,
} from "../../include/function";
import { useNotification } from "../../Toast/ToastProvider";
import Spinner from "../add-ons/Spinner";
import "../../styles/Super.css";
import Slider from "react-slick";
import { MinusCircle, PlusCircle } from "react-feather";
import { useNavigate, useParams } from "react-router-dom";
import CustomNumberInput from "../custom/CustomNumberInput";

const ProductForm = ({ type, from, readonly = false }) => {
  const user = getAdmin();
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useNotification();
  const mainImageElement = useRef();
  const extraImagesElement = useRef();
  const sliderRef = useRef(null);
  const [saving, setSaving] = useState(false);
  const [fetchingProduct, setFetchingProduct] = useState(type === EDIT);
  const [fetchingCategory, setFetchingCategory] = useState(true);
  const [saveExtraImagesLoading, setSaveExtraImagesLoading] = useState(false);
  const [saveMainImageLoading, setSaveMainImageLoading] = useState(false);
  const [product, setProduct] = useState({});
  const [categoryList, setCategoryList] = useState([]);
  const [brand, setBrand] = useState("");
  const [shopId, setShopId] = useState("");
  const [stockAvail, setstockAvail] = useState("yes");
  const [stockAvailError, setstockAvailError] = useState("");
  const [fetchingShops, setFetchingShops] = useState(false);
  const [name, setName] = useState("");
  const [highlight, setHighlight] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [code, setCode] = useState("0");
  const [price, setPrice] = useState("");
  const [tax, setTax] = useState("");
  const [cgst, setCgst] = useState("");
  const [sgst, setSgst] = useState("");
  const [taxError, setTaxError] = useState("");
  const [cgstError, setCgstError] = useState("");
  const [sgstError, setSgstError] = useState("");
  const [mainImage, setMainImage] = useState("");
  const [mainImagePreview, setMainImagePreview] = useState("");
  const [extraImages, setExtraImages] = useState([]);
  const [extraImagesPreview, setExtraImagesPreview] = useState([]);
  const [b2cDiscountMode, setB2cDiscountMode] = useState("");
  const [b2cDiscountValue, setB2cDiscountValue] = useState("");
  const [b2cDiscountLabel, setB2cDiscountLabel] = useState("");
  const [b2bDiscountMode, setB2bDiscountMode] = useState("");
  const [b2bDiscountValue, setB2bDiscountValue] = useState("");
  const [b2bPriceDiffMode, setB2bPriceDiffMode] = useState("");
  const [b2bRateValue, setB2bRateValue] = useState("");
  const [b2bDiscountLabel, setB2bDiscountLabel] = useState("");
  const [discountLabel, setDiscountLabel] = useState("");
  const [warrantyMode, setWarrantyMode] = useState("");
  const [warrantyPeriod, setWarrantyPeriod] = useState("");
  const [warrantyLabel, setWarrantyLabel] = useState("");
  const [deliveryCharge, setDeliveryCharge] = useState("0");
  const [status, setStatus] = useState(true);
  const [nameError, setNameError] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [brandError, setBrandError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [highlightError, setHighlightError] = useState("");
  const [codeError, setCodeError] = useState("");
  const [priceError, setPriceError] = useState("");
  const [mainImageError, setMainImageError] = useState("");
  const [extraImagesError, setExtraImagesError] = useState("");
  const [b2cDiscountModeError, setB2cDiscountModeError] = useState("");
  const [b2cDiscountValueError, setB2cDiscountValueError] = useState("");
  const [b2cDiscountLabelError, setB2cDiscountLabelError] = useState("");
  const [b2bDiscountModeError, setB2bDiscountModeError] = useState("");
  const [b2bDiscountValueError, setB2bDiscountValueError] = useState("");
  const [b2bDiscountLabelError, setB2bDiscountLabelError] = useState("");
  const [warrantyModeError, setWarrantyModeError] = useState("");
  const [warrantyPeriodError, setWarrantyPeriodError] = useState("");
  const [warrantyLabelError, setWarrantyLabelError] = useState("");
  const [weight, setWeight] = useState("");
  const [weightError, setWeightError] = useState("");
  const [shops, setShops] = useState([]);
  const [brands, setBrands] = useState([]);
  const [basedOn, setBasedOn] = useState("bags");
  const [typeGradeError, setTypeGradeError] = useState("");
  const [gradeError, setGradeError] = useState("");
  const [certificationError, setCertificationError] = useState("");
  const [typeGrade, setTypeGrade] = useState("");
  const [grade, setGrade] = useState("");
  const [b2cFlag, setB2cFlag] = useState(true);
  const [b2bFlag, setB2bFlag] = useState(false);
  const [certification, setCertification] = useState("");
  const [showB2C, setShowB2C] = useState(true);
  const [showB2B, setShowB2B] = useState(false);
  const [specGroups, setSpecGroups] = useState([]);
  const [specValues, setSpecValues] = useState({});
  const [specGroupsLoaded, setSpecGroupsLoaded] = useState(false);
  const [sellingPriceB2CInput, setSellingPriceB2CInput] = useState("");
  const [sellingPriceB2BInput, setSellingPriceB2BInput] = useState("");
  const [originalCategoryIds, setOriginalCategoryIds] = useState([]);
  const productHydratedRef = useRef(false);
  const [qtyPriceRows, setQtyPriceRows] = useState([
    { min: "", max: "", setB2bPrice: "", setB2cPrice: "" },
  ]);
  const [qtyPriceErrors, setQtyPriceErrors] = useState([
    { min: "", max: "", setB2bPrice: "", setB2cPrice: "" },
  ]);
  const [descriptionEditorState, setDescriptionEditorState] = useState(
    EditorState.createEmpty(),
  );
  const [highlightEditorState, setHighlightEditorState] = useState(
    EditorState.createEmpty(),
  );
  const [steelB2CPrices, setSteelB2CPrices] = useState([
    {
      diameter: "06 mm",
      retailPrice: "",
      sellingPrice: "",
      discountMode: "",
      discountValue: "",
    },
    {
      diameter: "08 mm",
      retailPrice: "",
      sellingPrice: "",
      discountMode: "",
      discountValue: "",
    },
    {
      diameter: "10 mm",
      retailPrice: "",
      sellingPrice: "",
      discountMode: "",
      discountValue: "",
    },
    {
      diameter: "12 mm",
      retailPrice: "",
      sellingPrice: "",
      discountMode: "",
      discountValue: "",
    },
    {
      diameter: "16 mm",
      retailPrice: "",
      sellingPrice: "",
      discountMode: "",
      discountValue: "",
      priceDiff: "",
      rateValue: "",
    },
    {
      diameter: "18 mm",
      retailPrice: "",
      sellingPrice: "",
      discountMode: "",
      discountValue: "",
      priceDiff: "",
      rateValue: "",
    },
    {
      diameter: "20 mm",
      retailPrice: "",
      sellingPrice: "",
      discountMode: "",
      discountValue: "",
    },
    {
      diameter: "25 mm",
      retailPrice: "",
      sellingPrice: "",
      discountMode: "",
      discountValue: "",
    },
    {
      diameter: "32 mm",
      retailPrice: "",
      sellingPrice: "",
      discountMode: "",
      discountValue: "",
    },
  ]);
  // Add this function near the top of the file, after imports
  const decodeHtmlEntities = (str) => {
    if (!str || typeof str !== "string") return str;
    const textarea = document.createElement("textarea");
    textarea.innerHTML = str;
    return textarea.value;
  };
  const [steelB2BPrices, setSteelB2BPrices] = useState([
    {
      diameter: "06 mm",
      retailPrice: "",
      sellingPrice: "",
      discountMode: "",
      discountValue: "",
      priceDiff: "",
      rateValue: "",
    },
    {
      diameter: "08 mm",
      retailPrice: "",
      sellingPrice: "",
      discountMode: "",
      discountValue: "",
      priceDiff: "",
      rateValue: "",
    },
    {
      diameter: "10 mm",
      retailPrice: "",
      sellingPrice: "",
      discountMode: "",
      discountValue: "",
      priceDiff: "",
      rateValue: "",
    },
    {
      diameter: "12 mm",
      retailPrice: "",
      sellingPrice: "",
      discountMode: "",
      discountValue: "",
      priceDiff: "",
      rateValue: "",
    },
    {
      diameter: "16 mm",
      retailPrice: "",
      sellingPrice: "",
      discountMode: "",
      discountValue: "",
      priceDiff: "",
      rateValue: "",
    },
    {
      diameter: "18 mm",
      retailPrice: "",
      sellingPrice: "",
      discountMode: "",
      discountValue: "",
      priceDiff: "",
      rateValue: "",
    },
    {
      diameter: "20 mm",
      retailPrice: "",
      sellingPrice: "",
      discountMode: "",
      discountValue: "",
      priceDiff: "",
      rateValue: "",
    },
    {
      diameter: "25 mm",
      retailPrice: "",
      sellingPrice: "",
      discountMode: "",
      discountValue: "",
      priceDiff: "",
      rateValue: "",
    },
    {
      diameter: "32 mm",
      retailPrice: "",
      sellingPrice: "",
      discountMode: "",
      discountValue: "",
      priceDiff: "",
      rateValue: "",
    },
  ]);
  const STEEL_GRADES = [
    { value: "Fe 415", label: "Fe 415" },
    { value: "Fe 500", label: "Fe 500" },
    { value: "Fe 500D", label: "Fe 500D" },
    { value: "Fe 550", label: "Fe 550" },
    { value: "Fe 550D", label: "Fe 550D" },
    { value: "Fe 600", label: "Fe 600" },
    { value: "CRS", label: "CRS" },
  ];
  // steel
  const calculateDiscountValue = (retail, selling, mode) => {
    const r = parseFloat(retail);
    const s = parseFloat(selling);
    if (isNaN(r) || isNaN(s) || r <= 0 || s > r || s < 0) return "";
    if (mode === "amount") {
      return (r - s).toFixed(2);
    } else if (mode === "percent") {
      return Math.round(((r - s) / r) * 100).toString();
    }
    return "";
  };
  // Recalculate B2B rateValue for a specific index
  const recalculateRateValueForIndex = (b2cSelling, b2bSelling, mode) => {
    if (
      isNaN(parseFloat(b2cSelling)) ||
      isNaN(parseFloat(b2bSelling)) ||
      parseFloat(b2cSelling) <= 0
    ) {
      return "";
    }
    const diff = parseFloat(b2cSelling) - parseFloat(b2bSelling);
    if (mode === "amount") {
      return diff.toFixed(2);
    } else if (mode === "percent") {
      return Math.round((diff / parseFloat(b2cSelling)) * 100).toString();
    }
    return "";
  };
  const calculateSellingPriceFromDiscount = (retail, discountValue, mode) => {
    const r = parseFloat(retail);
    const d = parseFloat(discountValue);
    if (isNaN(r) || r <= 0) return "";
    if (isNaN(d)) return ""; // Allow d = 0

    if (mode === "amount") {
      const sp = r - d;
      return sp >= 0 ? sp.toFixed(2) : "";
    } else if (mode === "percent") {
      const sp = r - (r * d) / 100;
      return sp >= 0 ? sp.toFixed(2) : "";
    }
    return "";
  };
  const calculateB2bDiscountFromSelling = useCallback(
    (selling) => {
      const retail = parseFloat(price);
      const sell = parseFloat(selling);
      if (isNaN(retail) || isNaN(sell) || retail <= 0) return "";
      if (b2bDiscountMode === "amount") {
        return (retail - sell).toFixed(2);
      } else if (b2bDiscountMode === "percent") {
        const percent = ((retail - sell) / retail) * 100;
        return Math.round(percent).toString();
      }
      return "";
    },
    [price, b2bDiscountMode],
  );
  const calculateB2cDiscountFromSelling = useCallback(
    (selling) => {
      const retail = parseFloat(price);
      const sell = parseFloat(selling);
      if (isNaN(retail) || isNaN(sell) || retail <= 0) return "";

      if (b2cDiscountMode === "amount") {
        return (retail - sell).toFixed(2);
      }

      if (b2cDiscountMode === "percent") {
        const percent = (((retail - sell) / retail) * 100).toFixed(2);
        return Math.round(percent);
      }

      return "";
    },
    [price, b2cDiscountMode],
  );
  useEffect(() => {
    if (sellingPriceB2CInput !== "" && price !== "") {
      const disc = calculateB2cDiscountFromSelling(sellingPriceB2CInput);
      setB2cDiscountValue(disc);
    } else {
      setB2cDiscountValue("");
    }
  }, [
    price,
    sellingPriceB2CInput,
    b2cDiscountMode,
    calculateB2cDiscountFromSelling,
  ]);
  useEffect(() => {
    if (sellingPriceB2BInput !== "" && price !== "") {
      const disc = calculateB2bDiscountFromSelling(sellingPriceB2BInput);
      setB2bDiscountValue(disc);
    } else {
      setB2bDiscountValue("");
    }
  }, [
    price,
    sellingPriceB2BInput,
    b2bDiscountMode,
    calculateB2bDiscountFromSelling,
  ]);
  const calculateB2bRateValue = () => {
    const retail = parseFloat(price);
    const b2c = parseFloat(sellingPriceB2CInput);
    const b2b = parseFloat(sellingPriceB2BInput);

    // If any value is invalid or B2B price > B2C price, return empty
    if (isNaN(retail) || isNaN(b2c) || isNaN(b2b) || b2b > b2c || b2c <= 0) {
      return "Not Matching";
    }

    const diff = b2c - b2b;

    if (b2bPriceDiffMode === "amount") {
      return diff.toFixed(2);
    } else if (b2bPriceDiffMode === "percent") {
      const percent = ((diff / b2c) * 100).toFixed(2);
      return Math.round(percent);
    }

    return "";
  };
  useEffect(() => {
    const rate = calculateB2bRateValue();
    setB2bRateValue(rate);
  }, [price, sellingPriceB2CInput, sellingPriceB2BInput, b2bPriceDiffMode]);
  const handleSellingPriceB2BInput = (value) => {
    setSellingPriceB2BInput(value);
  };
  const handleSellingPriceB2CInput = (value) => {
    setSellingPriceB2CInput(value);
  };
  const inputStyle = {
    borderRadius: "5px",
    fontWeight: "400",
    outline: "none",
    width: "100%",
    padding: "11px 24px",
    backgroundColor: "transparent !important",
    border: "1px solid var(--gray-100)",
    color: "hsl(var(--black))",
  };
  useEffect(() => {
    if (category) {
      api
        .get(`/brand/?categoryId=${category}`, adminReqConfig())
        .then((res) => setBrands(res.data.data))
        .catch(() => setBrands([]));
    } else {
      setBrands([]);
    }
  }, [category]);
  const allImages = [
    ...(mainImagePreview ? [mainImagePreview] : []),
    ...extraImagesPreview,
  ];
  const getShops = (afterGet) => {
    setFetchingShops(true);
    api
      .get("/shop/", superAdminReqConfig())
      .then((response) => {
        if (response.status === 200) {
          setShops(response.data.data);
          if (afterGet) afterGet(response.data.data);
        }
      })
      .catch((error) => {
        setShops([]);
        if (afterGet) afterGet([]);
      })
      .finally(() => setFetchingShops(false));
  };
  const getProduct = useCallback(() => {
    setFetchingProduct(true);
    api
      .get("/product/?id=" + id, adminReqConfig())
      .then((response) => {
        if (response.status === 200) {
          setProduct(response.data.data[0]);
        }
      })
      .catch((error) => {
        setProduct([]);
      })
      .finally(() => setFetchingProduct(false));
  }, [id]);
  const handleName = (value) => {
    setNameError("");
    setName(value);
  };
  const handleCategory = (value) => {
    setCategoryError("");
    setCategory(value);
  };
  const handleBrand = (value) => {
    setBrandError("");
    setBrand(value);
  };
  const handleTax = (value) => {
    setTaxError("");
    setTax(value);
  };
  const handleCgst = (value) => {
    setCgstError("");
    setCgst(value);
  };
  const handleSgst = (value) => {
    setSgstError("");
    setSgst(value);
  };
  const handlePrice = (value) => {
    setPriceError("");
    setPrice(value);
  };
  const handleWeight = (value) => {
    setWeightError("");
    setWeight(value);
  };
  const handleMainImage = (image) => {
    setMainImageError("");
    if (image.length > 0) {
      image = image[0];
      if (
        image.type === "image/jpeg" ||
        image.type === "image/jpg" ||
        image.type === "image/png" ||
        image.type === "image/webp"
      ) {
        if (image.size / 1024 / 1024 <= 3) {
          let reader = new FileReader();
          reader.readAsDataURL(image);
          reader.onloadend = (e) => setMainImagePreview(reader.result);
          setMainImage(image);
        } else setMainImageError("Image seems too large");
      } else setMainImageError("jpeg, jpg and png are supported");
    } else setMainImageError("Choose an image");

    mainImageElement.current.value = "";
  };
  const handleExtraImages = (images) => {
    setExtraImagesError("");
    let validImages = [];
    if (images.length > 0) {
      for (let index = 0; index < images.length; index++) {
        const image = images[index];
        if (
          image.type === "image/jpeg" ||
          image.type === "image/jpg" ||
          image.type === "image/png" ||
          image.type === "image/webp"
        ) {
          if (image.size / 1024 / 1024 <= 3) {
            validImages.push(image);
          } else setExtraImagesError("Some images seems too large");
        } else setExtraImagesError("jpeg, jpg and png are supported");
      }
    } else setExtraImagesError("Choose an image");

    if (validImages.length > 0) {
      setExtraImagesPreview([
        ...extraImagesPreview,
        ...Array.from(validImages).map((image) => URL.createObjectURL(image)),
      ]);
      setExtraImages([...extraImages, ...validImages]);
    }

    extraImagesElement.current.value = "";
  };
  const handleB2cDiscountMode = (value) => {
    setB2cDiscountModeError("");
    setB2cDiscountMode(value);
  };
  const handleB2bDiscountMode = (value) => {
    setB2bDiscountModeError("");
    setB2bDiscountMode(value);
  };
  const handleB2bPriceDiffMode = (value) => {
    setB2bDiscountModeError("");
    setB2bPriceDiffMode(value);
  };
  const handleWarrantyMode = (value) => {
    setWarrantyModeError("");
    setWarrantyMode(value);
  };
  const handleWarrantyPeriod = (value) => {
    setWarrantyPeriodError("");
    setWarrantyPeriod(value);
  };
  const handleWarrantyLabel = (value) => {
    setWarrantyLabelError("");
    setWarrantyLabel(value);
  };
  // Update the handleQtyInputChange function
  const handleQtyInputChange = (index, field, value) => {
    setQtyPriceRows((prev) =>
      prev.map((row, i) => (i === index ? { ...row, [field]: value } : row)),
    );
    // Clear error for this field
    setQtyPriceErrors((prev) =>
      prev.map((err, i) => (i === index ? { ...err, [field]: "" } : err)),
    );
  };
  // Update the add row function
  const addQtyPriceRow = () => {
    setQtyPriceRows([
      ...qtyPriceRows,
      { min: "", max: "", setB2bPrice: "", setB2cPrice: "" },
    ]);
    setQtyPriceErrors([
      ...qtyPriceErrors,
      { min: "", max: "", setB2bPrice: "", setB2cPrice: "" },
    ]);
  };
  // Update the delete row function
  const deleteQtyPriceRow = async (index, rowId) => {
    if (rowId) {
      try {
        await api.delete(`/product_qty_price/?id=${rowId}`, adminReqConfig());
        toast({ type: SUCCESS, message: "Quantity & Price entry deleted!" });
      } catch (err) {
        toast({
          type: ERROR,
          message: err.response?.data?.message || "Failed to delete entry",
        });
        return;
      }
    }
    // Handle removal from local state
    setQtyPriceRows((prev) => prev.filter((_, i) => i !== index));
    setQtyPriceErrors((prev) => prev.filter((_, i) => i !== index));
  };
  const handleTypeGrade = (value) => {
    setTypeGradeError("");
    setTypeGrade(value);
  };
  const handleGrade = (value) => {
    setGradeError("");
    setGrade(value);
  };
  const handleCertification = (value) => {
    setCertificationError("");
    setCertification(value);
  };
  const removeExtraImage = (image) => {
    if (readonly) return;
    if (image.id) {
      api
        .delete("/product_images/?id=" + image.id, adminReqConfig())
        .then((response) => {
          if (response.status === 200) {
            removeExtraImageFromState(image);
          }
          toast({ type: SUCCESS, message: "product Image Deleted" });
        })
        .catch((error) => {});
    } else {
      removeExtraImageFromState(image);
    }
  };
  const removeExtraImageFromState = (imageToRemove) => {
    const getPreviewUrl = (img) => {
      if (img instanceof File) {
        return URL.createObjectURL(img);
      }
      if (img.imageUrl) {
        return img.imageUrl;
      }
      return "";
    };

    const previewToRemove = getPreviewUrl(imageToRemove);

    const newExtraImages = extraImages.filter((img) => {
      if (imageToRemove.id && img.id) {
        return img.id !== imageToRemove.id;
      }
      if (imageToRemove instanceof File && img instanceof File) {
        return img !== imageToRemove;
      }
      return true;
    });

    const newExtraImagesPreview = extraImagesPreview.filter(
      (url) => url !== previewToRemove,
    );

    setExtraImages(newExtraImages);
    setExtraImagesPreview(newExtraImagesPreview);

    if (imageToRemove instanceof File) {
      URL.revokeObjectURL(previewToRemove);
    }
  };
  const DEFAULT_STEEL_DIAMETERS = [
    "06 mm",
    "08 mm",
    "10 mm",
    "12 mm",
    "16 mm",
    "18 mm",
    "20 mm",
    "25 mm",
    "32 mm",
  ];
  const INITIAL_STEEL_B2C_PRICES = DEFAULT_STEEL_DIAMETERS.map((d) => ({
    diameter: d,
    retailPrice: "",
    sellingPrice: "",
    discountMode: "",
    discountValue: "",
  }));
  const INITIAL_STEEL_B2B_PRICES = DEFAULT_STEEL_DIAMETERS.map((d) => ({
    diameter: d,
    retailPrice: "",
    sellingPrice: "",
    discountMode: "",
    discountValue: "",
    priceDiff: "",
    rateValue: "",
  }));
  const clearFields = () => {
    setBrand("");
    setBrandError("");
    setMainImage("");
    setMainImagePreview("");
    setExtraImages([]);
    setExtraImagesPreview([]);
    setWeight("");
    setWeightError("");
    setPrice("");
    setPriceError("");
    setTax("");
    setTaxError("");
    setCgst("");
    setCgstError("");
    setSgst("");
    setSgstError("");
    setB2bDiscountLabel("");
    setB2bDiscountLabelError("");
    setB2bDiscountMode("");
    setB2bDiscountModeError("");
    setB2bDiscountValue("");
    setB2bDiscountValueError("");
    setB2cDiscountLabel("");
    setB2cDiscountLabelError("");
    setB2cDiscountMode("");
    setB2cDiscountModeError("");
    setB2cDiscountValue("");
    setB2cDiscountValueError("");
    setDiscountLabel("");
    setDescription("");
    setDescriptionEditorState(EditorState.createEmpty());
    setDescriptionError("");
    setHighlight("");
    setHighlightEditorState(EditorState.createEmpty());
    setHighlightError("");
    setSpecValues({});
    setTypeGradeError("");
    setTypeGrade("");
    setGradeError("");
    setGrade("");
    setCertificationError("");
    setCertification("");
    setQtyPriceRows([{ min: "", max: "", setB2bPrice: "", setB2cPrice: "" }]);
    setQtyPriceErrors([{ min: "", max: "", setB2bPrice: "", setB2cPrice: "" }]);
    setBasedOn("bags");
    setName("");
    setNameError("");
    setWarrantyLabel("");
    setWarrantyLabelError("");
    setWarrantyMode("");
    setWarrantyModeError("");
    setWarrantyPeriod("");
    setWarrantyPeriodError("");
    setstockAvail("");
    setstockAvailError("");
    setCode("");
    setCodeError("");
    setDeliveryCharge("");
    setDeliveryCharge("");
    setCategory("");
    setCategoryError("");
    setSellingPriceB2CInput("");
    setSellingPriceB2BInput("");
    setSteelB2CPrices(INITIAL_STEEL_B2C_PRICES);
    setSteelB2BPrices(INITIAL_STEEL_B2B_PRICES);
  };
  const clearbrand = () => {
    setBrand("");
    setBrandError("");
  };
  const clearPrice = () => {
    setWeight("");
    setWeightError("");
    setPrice("");
    setPriceError("");
    setTax("");
    setTaxError("");
    setCgst("");
    setCgstError("");
    setSgst("");
    setSgstError("");
    setB2bDiscountLabel("");
    setB2bDiscountLabelError("");
    setB2bDiscountMode("");
    setB2bDiscountModeError("");
    setB2bDiscountValue("");
    setB2bDiscountValueError("");
    setB2cDiscountLabel("");
    setB2cDiscountLabelError("");
    setB2cDiscountMode("");
    setB2cDiscountModeError("");
    setB2cDiscountValue("");
    setB2cDiscountValueError("");
    setDiscountLabel("");
    setSellingPriceB2CInput("");
    setSellingPriceB2BInput("");
    setSteelB2CPrices(INITIAL_STEEL_B2C_PRICES);
    setSteelB2BPrices(INITIAL_STEEL_B2B_PRICES);
  };
  const clearDescription = () => {
    setDescription("");
    setDescriptionEditorState(EditorState.createEmpty());
    setDescriptionError("");
  };
  const clearHighlight = () => {
    setHighlight("");
    setHighlightEditorState(EditorState.createEmpty());
    setHighlightError("");
  };
  const clearSpecification = () => {
    setSpecValues({});
  };
  const clearGrade = () => {
    setTypeGradeError("");
    setTypeGrade("");
    setGradeError("");
    setGrade("");
    setCertificationError("");
    setCertification("");
  };
  // Update the clearQuantity function
  const clearQuantity = () => {
    setQtyPriceRows([{ min: "", max: "", setB2bPrice: "", setB2cPrice: "" }]);
    setQtyPriceErrors([{ min: "", max: "", setB2bPrice: "", setB2cPrice: "" }]);
    setBasedOn("bags");
  };
  const clearProductInformation = () => {
    setName("");
    setNameError("");
    setWarrantyLabel("");
    setWarrantyLabelError("");
    setWarrantyMode("");
    setWarrantyModeError("");
    setWarrantyPeriod("");
    setWarrantyPeriodError("");
  };
  const clearcategory = () => {
    setCategory("");
    setCategoryError("");
  };

  console.log("user", user);

  const handleSave = async () => {
    let error = false;
    if (error) return;
    setSaving(true);

    try {
      if (type === ADD) {
        // --- ADD FLOW ---
        const formData = new FormData();
        formData.append(
          "shopId",
          from === "super" ? shopId : String(user.shopId).trim(),
        );
        formData.append("stockAvail", String(stockAvail));
        formData.append("name", String(name).trim());
        formData.append("highlight", highlight?.trim() || "");
        formData.append("category", JSON.stringify([category]));
        formData.append("brandId", brand);
        formData.append("description", String(description).trim());
        formData.append("code", String(code).trim());
        formData.append(
          "price",
          categoryList.find((cat) => cat.id === category)?.name === "Steel" ||
            categoryList.find((cat) => cat.id === category)?.name === "Steels"
            ? "0"
            : String(price).trim(),
        );
        formData.append("status", status === true ? "active" : "inactive");
        formData.append("b2bFlag", b2bFlag ? "1" : "0");
        formData.append("b2cFlag", b2cFlag ? "1" : "0");
        formData.append("grade", String(grade).trim());
        formData.append("type", String(typeGrade).trim());
        formData.append("tax", String(tax).trim());
        formData.append("cgst", String(cgst).trim());
        formData.append("sgst", String(sgst).trim());
        formData.append("certification", String(certification).trim());
        formData.append("b2cDiscountMode", String(b2cDiscountMode).trim());
        formData.append("b2cDiscountValue", String(b2cDiscountValue).trim());
        formData.append("b2bDiscountMode", String(b2bDiscountMode).trim());
        formData.append("b2bDiscountValue", String(b2bDiscountValue).trim());
        formData.append("discountLabel", String(discountLabel).trim());
        formData.append("warrantyMode", String(warrantyMode).trim());
        formData.append("warrantyPeriod", String(warrantyPeriod).trim());
        formData.append("warrantyLabel", String(warrantyLabel));
        formData.append("deliveryCharge", String(deliveryCharge).trim());
        formData.append("weight", String(weight).trim());
        if (mainImage) formData.append("mainImage", mainImage);
        extraImages.forEach((img) => {
          if (!img.id) formData.append("extraImages[]", img);
        });

        const response = await api.post(
          "/product/",
          formData,
          adminReqConfig(),
        );
        if (response.status === 200) {
          const productId = response.data.data?.id;

          // --- SPECIFICATIONS ---
          const specPayload = [];
          Object.entries(specValues).forEach(([specId, value]) => {
            if (!value) return;
            const spec = specGroups.find(
              (s) => String(s.id) === String(specId),
            );
            if (!spec) return;
            specPayload.push({
              productId,
              groupName: spec.groupName.trim(),
              title: spec.title.trim(),
              description: Array.isArray(value)
                ? value.join(",")
                : String(value),
            });
          });

          // --- 🔥 QUANTITY & PRICE - UNIFIED APPROACH ---
          const qtyPricePayload = [];
          qtyPriceRows.forEach((row) => {
            if (row.min && row.max && (row.setB2cPrice || row.setB2bPrice)) {
              qtyPricePayload.push({
                productId,
                basedOn: basedOn,
                minQty: String(row.min),
                maxQty: String(row.max),
                setB2cPrice: showB2C ? String(row.setB2cPrice || "") : "",
                setB2bPrice: showB2B ? String(row.setB2bPrice || "") : "",
              });
            }
          });

          // --- STEEL PRICING ---
          const steelPricingPayload = [];
          if (
            categoryList.find((cat) => cat.id === category)?.name === "Steel" ||
            categoryList.find((cat) => cat.id === category)?.name === "Steels"
          ) {
            const steelMap = {};
            steelB2CPrices.forEach((item) => {
              if (!item.diameter) return;
              steelMap[item.diameter] = {
                productId,
                title: item.diameter,
                price: String(item.retailPrice || ""),
                b2cDiscountMode: item.discountMode || "",
                b2cDiscountValue: String(item.discountValue || ""),
                b2bDiscountMode: "",
                b2bDiscountValue: "",
                priceDiff: "",
                rateValue: "",
              };
            });
            steelB2BPrices.forEach((item) => {
              if (!item.diameter) return;
              if (!steelMap[item.diameter]) {
                steelMap[item.diameter] = {
                  productId,
                  title: item.diameter,
                  price: String(item.retailPrice || ""),
                  b2cDiscountMode: "",
                  b2cDiscountValue: "",
                  b2bDiscountMode: item.discountMode || "",
                  b2bDiscountValue: String(item.discountValue || ""),
                  priceDiff: item.priceDiff || "",
                  rateValue: String(item.rateValue || ""),
                };
              } else {
                steelMap[item.diameter].b2bDiscountMode =
                  item.discountMode || "";
                steelMap[item.diameter].b2bDiscountValue = String(
                  item.discountValue || "",
                );
                steelMap[item.diameter].priceDiff = item.priceDiff || "";
                steelMap[item.diameter].rateValue = String(
                  item.rateValue || "",
                );
              }
            });
            steelPricingPayload.push(
              ...Object.values(steelMap).filter(
                (item) =>
                  item.price && (item.b2cDiscountMode || item.b2bDiscountMode),
              ),
            );
          }

          const promises = [];
          if (specPayload.length > 0)
            promises.push(
              api.post(
                "/product_specification/",
                specPayload,
                adminReqConfig(),
              ),
            );
          if (qtyPricePayload.length > 0)
            promises.push(
              api.post(
                "/product_qty_price/",
                qtyPricePayload,
                adminReqConfig(),
              ),
            );
          if (steelPricingPayload.length > 0)
            promises.push(
              api.post(
                "/product_variant/",
                steelPricingPayload,
                adminReqConfig(),
              ),
            );

          await Promise.all(promises);
          clearFields();
          toast({ type: SUCCESS, message: "Product added successfully!" });
          navigate("/admin/product/productList");
        }
      } else if (type === EDIT) {
        // --- EDIT FLOW ---
        await handleSaveExtraImages();
        if (mainImage instanceof File) {
          await handleSaveMainImage();
        }

        const productData = {
          id: String(id).trim(),
          shopId: from === "super" ? shopId : String(user.shopId).trim(),
          stockAvail: String(stockAvail),
          name: String(name).trim(),
          highlight: String(highlight).trim(),
          status: status === true ? "active" : "inactive",
          category: (() => {
            if (category && category !== originalCategoryIds[0]) {
              return [category, ...originalCategoryIds.slice(1)];
            }
            return originalCategoryIds.length > 0
              ? originalCategoryIds
              : category
                ? [category]
                : [];
          })(),
          brandId: brand,
          description: String(description).trim(),
          code: String(code).trim(),
          price:
            categoryList.find((cat) => cat.id === category)?.name === "Steel" ||
            categoryList.find((cat) => cat.id === category)?.name === "Steels"
              ? "0"
              : String(price).trim(),
          mainImage,
          b2bFlag: b2bFlag ? "1" : "0",
          b2cFlag: b2cFlag ? "1" : "0",
          grade: String(grade).trim(),
          type: String(typeGrade).trim(),
          tax: String(tax).trim(),
          cgst: String(cgst).trim(),
          sgst: String(sgst).trim(),
          certification: String(certification).trim(),
          b2cDiscountMode: String(b2cDiscountMode).trim(),
          b2cDiscountValue: String(b2cDiscountValue).trim(),
          b2bDiscountMode: String(b2bDiscountMode).trim(),
          b2bDiscountValue: String(b2bDiscountValue).trim(),
          discountLabel: String(discountLabel).trim(),
          warrantyMode: String(warrantyMode).trim(),
          warrantyPeriod: String(warrantyPeriod).trim(),
          warrantyLabel: String(warrantyLabel),
          deliveryCharge: String(deliveryCharge).trim(),
          weight: String(weight).trim(),
        };

        await api.put(
          `/product/?id=${id}&flag=updateproduct`,
          productData,
          adminReqConfig(),
        );
        toast({ type: SUCCESS, message: "Product updated!" });
        navigate("/admin/product/productList");

        // === 🔥 QUANTITY & PRICE - UNIFIED APPROACH (EDIT) ===
        const qtyPriceToUpdate = [];
        const qtyPriceToCreate = [];

        qtyPriceRows.forEach((row) => {
          if (!row.min || !row.max || (!row.setB2cPrice && !row.setB2bPrice))
            return;
          const payload = {
            productId: id,
            basedOn: basedOn,
            minQty: String(row.min),
            maxQty: String(row.max),
            setB2cPrice: showB2C ? String(row.setB2cPrice || "") : "",
            setB2bPrice: showB2B ? String(row.setB2bPrice || "") : "",
          };
          if (row.id) {
            qtyPriceToUpdate.push({ ...payload, id: row.id });
          } else {
            qtyPriceToCreate.push(payload);
          }
        });

        const qtyPricePromises = [];
        if (qtyPriceToUpdate.length > 0) {
          qtyPricePromises.push(
            api.put("/product_qty_price/", qtyPriceToUpdate, adminReqConfig()),
          );
        }
        if (qtyPriceToCreate.length > 0) {
          qtyPricePromises.push(
            api.post("/product_qty_price/", qtyPriceToCreate, adminReqConfig()),
          );
        }
        if (qtyPricePromises.length > 0) {
          await Promise.all(qtyPricePromises);
          toast({ type: SUCCESS, message: "Quantity & Price updated!" });
        }

        // === STEEL PRICING UPDATE ===
        if (
          categoryList.find((cat) => cat.id === category)?.name === "Steel" ||
          categoryList.find((cat) => cat.id === category)?.name === "Steels"
        ) {
          const steelMap = {};
          steelB2CPrices.forEach((item) => {
            if (!item.diameter) return;
            steelMap[item.diameter] = {
              productId: id,
              title: item.diameter,
              price: String(item.retailPrice || ""),
              b2cDiscountMode: item.discountMode || "",
              b2cDiscountValue: String(item.discountValue || ""),
              b2bDiscountMode: "",
              b2bDiscountValue: "",
              priceDiff: "",
              rateValue: "",
              id: item.id,
            };
          });
          steelB2BPrices.forEach((item) => {
            if (!item.diameter) return;
            if (!steelMap[item.diameter]) {
              steelMap[item.diameter] = {
                productId: id,
                title: item.diameter,
                price: String(item.retailPrice || ""),
                b2cDiscountMode: "",
                b2cDiscountValue: "",
                b2bDiscountMode: item.discountMode || "",
                b2bDiscountValue: String(item.discountValue || ""),
                priceDiff: item.priceDiff || "",
                rateValue: String(item.rateValue || ""),
                id: item.id,
              };
            } else {
              steelMap[item.diameter].b2bDiscountMode = item.discountMode || "";
              steelMap[item.diameter].b2bDiscountValue = String(
                item.discountValue || "",
              );
              steelMap[item.diameter].priceDiff = item.priceDiff || "";
              steelMap[item.diameter].rateValue = String(item.rateValue || "");
              if (!steelMap[item.diameter].id && item.id) {
                steelMap[item.diameter].id = item.id;
              }
            }
          });

          const steelPricingPayload = Object.values(steelMap).filter(
            (item) => {
              // item.price && (item.b2cDiscountMode || item.b2bDiscountMode),
              if (item.id) return true;

              // 2. If it's a brand new row, only send it if it has actual data.
              return item.price || item.b2cDiscountMode || item.b2bDiscountMode;
            }
          );
          const steelToUpdate = steelPricingPayload.filter((item) => item.id);
          const steelToCreate = steelPricingPayload.filter((item) => !item.id);

          const steelPromises = [];
          if (steelToUpdate.length > 0) {
            steelPromises.push(
              api.put("/product_variant/", steelToUpdate, adminReqConfig()),
            );
          }
          if (steelToCreate.length > 0) {
            steelPromises.push(
              api.post("/product_variant/", steelToCreate, adminReqConfig()),
            );
          }
          if (steelPromises.length > 0) {
            await Promise.all(steelPromises);
            toast({ type: SUCCESS, message: "Steel Pricing updated!" });
          }
        }

        // === SPECIFICATIONS UPDATE ===
        const existingSpecsRes = await api.get(
          `/product_specification/?productId=${id}`,
          adminReqConfig(),
        );
        const existingSpecs = existingSpecsRes.data.data || [];
        const specPayloadToUpdate = [];
        const specPayloadToCreate = [];

        for (const [specId, value] of Object.entries(specValues)) {
          if (!value) continue;
          const spec = specGroups.find((s) => String(s.id) === String(specId));
          if (!spec) continue;
          const payload = {
            productId: id,
            groupName: spec.groupName,
            title: spec.title,
            description: Array.isArray(value) ? value.join(",") : String(value),
          };
          const existing = existingSpecs.find(
            (es) => es.groupName === spec.groupName && es.title === spec.title,
          );
          if (existing?.id) {
            specPayloadToUpdate.push({ ...payload, id: existing.id });
          } else {
            specPayloadToCreate.push(payload);
          }
        }

        const specPromises = [];
        if (specPayloadToUpdate.length > 0) {
          specPromises.push(
            api.put(
              "/product_specification/",
              specPayloadToUpdate,
              adminReqConfig(),
            ),
          );
        }
        if (specPayloadToCreate.length > 0) {
          specPromises.push(
            api.post(
              "/product_specification/",
              specPayloadToCreate,
              adminReqConfig(),
            ),
          );
        }
        if (specPromises.length > 0) {
          await Promise.all(specPromises);
          toast({ type: SUCCESS, message: "Specifications updated!" });
        }
      }
    } catch (err) {
      console.error(err);
      toast({
        type: ERROR,
        message: err.response?.data?.message || err.message,
      });
    } finally {
      setSaving(false);
    }
  };
  const handleSaveExtraImages = () => {
    const images = extraImages.filter((ei) => !ei.id);
    if (images.length > 0) {
      const data = new FormData();
      data.append("productId", id);
      for (let index = 0; index < images.length; index++) {
        data.append("images[]", images[index]);
      }

      setSaveExtraImagesLoading(true);
      api
        .post("/product_images/", data, adminReqConfig())
        .then((response) => {
          if (response.status === 200) {
            toast({ type: SUCCESS, message: response.data.message });
          }
        })
        .catch((error) => {
          error.response
            ? toast({ type: ERROR, message: error.response.data.message })
            : toast({ type: ERROR, message: error.message });
        })
        .finally(() => setSaveExtraImagesLoading(false));
    }
  };
  const handleSaveMainImage = () => {
    return new Promise((resolve, reject) => {
      if (!(mainImage instanceof File)) {
        return resolve(null);
      }

      const data = new FormData();
      data.append("mainImage", mainImage);

      setSaveMainImageLoading(true);
      api
        .post(
          "/product/?id=" + id + "&flag=changemainimage",
          data,
          adminReqConfig(),
        )
        .then((response) => {
          if (response.status === 200) {
            toast({ type: SUCCESS, message: response.data.message });
            resolve(response.data);
          } else {
            reject(new Error("Unexpected response status: " + response.status));
          }
        })
        .catch((error) => {
          error.response
            ? toast({ type: ERROR, message: error.response.data.message })
            : toast({ type: ERROR, message: error.message });
          reject(error); // ✅ Reject on error
        })
        .finally(() => setSaveMainImageLoading(false));
    });
  };
  const getCategory = () => {
    setFetchingCategory(true);
    api
      .get("/category/?flag=exceptHome", adminReqConfig())
      .then((response) => {
        if (response.status === 200) {
          setCategoryList(response.data.data);
        }
      })
      .catch((error) => {})
      .finally(() => setFetchingCategory(false));
  };
  useEffect(() => {
    const html = draftToHtml(
      convertToRaw(descriptionEditorState.getCurrentContent()),
    );
    setDescription(html);
  }, [descriptionEditorState]);
  useEffect(() => {
    const html = draftToHtml(
      convertToRaw(highlightEditorState.getCurrentContent()),
    );
    setHighlight(html);
  }, [highlightEditorState]);

  useEffect(() => {
    getCategory();
    getShops();
  }, []);
  useEffect(() => {
    if (type === EDIT || type === VIEW) getProduct();
  }, [type, id]);
  useEffect(() => {
    if (!isEmptyObj(product) && !productHydratedRef.current) {
      productHydratedRef.current = true; // prevent re-hydration

      const categoryIds = product.category?.map((cat) => cat.categoryId) || [];
      const extraImages =
        product.images?.map((img) => ({
          id: img.id,
          imageUrl: baseURL + "/" + img.imageUrl,
        })) || [];

      // === Basic Fields ===
      setName(product.name || "");
      setCategory(categoryIds[0] || "");
      setOriginalCategoryIds(categoryIds);
      setBrand(product.brandId);
      setstockAvail(product.stockAvail || "yes");
      setCode(product.code || "0");
      setPrice(String(product.price || ""));
      setWeight(String(product.weight || ""));
      setMainImage(product.mainImage);
      setMainImagePreview(baseURL + "/" + product.mainImage);
      setExtraImages(extraImages);
      setExtraImagesPreview(extraImages.map((img) => img.imageUrl));

      // === Discount & Warranty ===
      setB2cDiscountMode(product.b2cDiscountMode || "");
      setB2cDiscountValue(String(product.b2cDiscountValue || ""));
      setB2cDiscountLabel(product.b2cDiscountLabel || "");
      setB2bDiscountMode(product.b2bDiscountMode || "");
      setB2bDiscountValue(String(product.b2bDiscountValue || ""));
      setB2bDiscountLabel(product.b2bDiscountLabel || "");
      setWarrantyMode(product.warrantyMode || "");
      setWarrantyPeriod(String(product.warrantyPeriod || 0));
      setWarrantyLabel(String(product.warrantyLabel || ""));
      setTax(String(product.tax || ""));
      setCgst(String(product.cgst || ""));
      setSgst(String(product.sgst || ""));
      setDeliveryCharge(String(product.deliveryCharge || "0"));

      // === Flags ===
      setB2cFlag(product.b2cFlag === 1);
      setB2bFlag(product.b2bFlag === 1);
      setShowB2C(product.b2cFlag === 1);
      setShowB2B(product.b2bFlag === 1);

      // === Grade & Certification ===
      setGrade(product.grade || "");
      setCertification(product.certification || "");
      setTypeGrade(product.type || "");
      setStatus(product.status === "active" || product.status === true);

      // === Rich Text Editors ===
      if (product.description) {
        const blocksFromHtml = htmlToDraft(product.description);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(
          contentBlocks,
          entityMap,
        );
        setDescriptionEditorState(EditorState.createWithContent(contentState));
      } else {
        setDescriptionEditorState(EditorState.createEmpty());
      }

      if (product.highlight) {
        const blocksFromHtml = htmlToDraft(product.highlight);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(
          contentBlocks,
          entityMap,
        );
        setHighlightEditorState(EditorState.createWithContent(contentState));
      } else {
        setHighlightEditorState(EditorState.createEmpty());
      }

      // === 🔥 QUANTITY & PRICE - UNIFIED APPROACH ===
      const qtyPrice = product["qtyAndPrice"] || [];
      if (qtyPrice.length > 0) {
        const firstBasedOn = qtyPrice[0]?.basedOn || "bags";
        setBasedOn(firstBasedOn);

        // Check if any row has B2B/B2C price data
        const hasB2BData = qtyPrice.some(
          (row) => row.setB2bPrice && row.setB2bPrice !== "",
        );
        const hasB2CData = qtyPrice.some(
          (row) => row.setB2cPrice && row.setB2cPrice !== "",
        );
        setShowB2B(hasB2BData);
        setShowB2C(hasB2CData);

        // Map API response to unified qtyPriceRows format
        const mapRow = (item) => ({
          id: item.id,
          min: String(item.minQty),
          max: String(item.maxQty),
          setB2cPrice: String(item.setB2cPrice || ""),
          setB2bPrice: String(item.setB2bPrice || ""),
        });

        // ✅ Set unified state - NO separate bagRows/weightRows/etc.
        setQtyPriceRows(qtyPrice.map(mapRow));
        setQtyPriceErrors([
          { min: "", max: "", setB2bPrice: "", setB2cPrice: "" },
        ]);
      } else {
        // Reset to default if no qtyPrice data
        setQtyPriceRows([
          { min: "", max: "", setB2bPrice: "", setB2cPrice: "" },
        ]);
        setQtyPriceErrors([
          { min: "", max: "", setB2bPrice: "", setB2cPrice: "" },
        ]);
        setBasedOn("bags");
      }

      // === Steel Pricing Hydration ===
      const productVariant = product["productVariant"] || [];
      const defaultDiameters = [
        "06 mm",
        "08 mm",
        "10 mm",
        "12 mm",
        "16 mm",
        "18 mm",
        "20 mm",
        "25 mm",
        "32 mm",
      ];

      const initialB2C = defaultDiameters.map((d) => ({
        diameter: d,
        retailPrice: "",
        sellingPrice: "",
        discountMode: "",
        discountValue: "",
      }));
      const initialB2B = defaultDiameters.map((d) => ({
        diameter: d,
        retailPrice: "",
        sellingPrice: "",
        discountMode: "",
        discountValue: "",
        priceDiff: "",
        rateValue: "",
      }));

      const b2cMap = {};
      productVariant
        .filter(
          (v) =>
            v.b2cDiscountMode !== undefined || v.b2cDiscountValue !== undefined,
        )
        .forEach((v) => {
          b2cMap[v.title] = {
            id: v.id,
            diameter: v.title,
            retailPrice: String(v.price || ""),
            sellingPrice: String(v.sellingPrice || ""),
            discountMode: v.b2cDiscountMode || "",
            discountValue: String(v.b2cDiscountValue || ""),
          };
        });

      const b2bMap = {};
      productVariant
        .filter(
          (v) => v.b2bDiscountMode !== undefined || v.priceDiff !== undefined,
        )
        .forEach((v) => {
          b2bMap[v.title] = {
            id: v.id,
            diameter: v.title,
            retailPrice: String(v.price || ""),
            sellingPrice: String(v.sellingPrice || ""),
            discountMode: v.b2bDiscountMode || "",
            discountValue: String(v.b2bDiscountValue || ""),
            priceDiff: v.priceDiff || "",
            rateValue: String(v.rateValue || ""),
          };
        });

      let hydratedB2C = initialB2C.map((item) =>
        b2cMap[item.diameter] ? { ...item, ...b2cMap[item.diameter] } : item,
      );
      let hydratedB2B = initialB2B.map((item) =>
        b2bMap[item.diameter] ? { ...item, ...b2bMap[item.diameter] } : item,
      );

      // Calculate sellingPrice from discount data
      hydratedB2C = hydratedB2C.map((item) => ({
        ...item,
        sellingPrice:
          item.retailPrice && item.discountMode
            ? calculateSellingPriceFromDiscount(
                item.retailPrice,
                item.discountValue,
                item.discountMode,
              )
            : "",
      }));
      hydratedB2B = hydratedB2B.map((item) => ({
        ...item,
        sellingPrice:
          item.retailPrice && item.discountMode
            ? calculateSellingPriceFromDiscount(
                item.retailPrice,
                item.discountValue,
                item.discountMode,
              )
            : "",
      }));

      setSteelB2CPrices(hydratedB2C);
      setSteelB2BPrices(hydratedB2B);

      // Recalculate top-level selling prices
      const retailPrice = String(product.price || "");
      const b2cSelling = calculateSellingPriceFromDiscount(
        retailPrice,
        String(product.b2cDiscountValue || ""),
        product.b2cDiscountMode || "",
      );
      const b2bSelling = calculateSellingPriceFromDiscount(
        retailPrice,
        String(product.b2bDiscountValue || ""),
        product.b2bDiscountMode || "",
      );
      setSellingPriceB2CInput(b2cSelling);
      setSellingPriceB2BInput(b2bSelling);

      // === Specifications Hydration ===
      if (specGroupsLoaded && specGroups.length > 0) {
        const specMap = {};
        (product.productSpecification || []).forEach((savedSpec) => {
          const matchingSpec = specGroups.find(
            (spec) =>
              spec.groupName === decodeHtmlEntities(savedSpec.groupName) &&
              spec.title === decodeHtmlEntities(savedSpec.title),
          );
          if (matchingSpec) {
            specMap[matchingSpec.id] = savedSpec.description;
          }
        });
        setSpecValues(specMap);
      }
    }
  }, [product, specGroups, specGroupsLoaded]);
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
  };
  useEffect(() => {
    if (category) {
      api
        .get(
          `/category_specification/?categoryId=${category}`,
          adminReqConfig(),
        )
        .then((res) => {
          if (res.status === 200) {
            const specs = res.data.data || [];
            // ✅ Decode groupName and title
            const decodedSpecs = specs.map((spec) => ({
              ...spec,
              groupName: decodeHtmlEntities(spec.groupName),
              title: decodeHtmlEntities(spec.title),
              options: decodeHtmlEntities(spec.options),
            }));
            setSpecGroups(decodedSpecs);
            setSpecGroupsLoaded(true);
            const initialValues = {};
            decodedSpecs.forEach((spec) => {
              initialValues[spec.id] = "";
            });
            setSpecValues(initialValues);
            if (!isEmptyObj(product)) {
              const specMap = {};
              (product.productSpecification || []).forEach((savedSpec) => {
                const matchingSpec = decodedSpecs.find(
                  (spec) =>
                    // ✅ FIX: Decode savedSpec.groupName before comparing
                    spec.groupName ===
                      decodeHtmlEntities(savedSpec.groupName) &&
                    spec.title === decodeHtmlEntities(savedSpec.title),
                );
                if (matchingSpec) {
                  specMap[matchingSpec.id] = savedSpec.description;
                }
              });
              setSpecValues(specMap);
            }
          }
        })
        .catch(() => {
          setSpecGroups([]);
          setSpecValues({});
          setSpecGroupsLoaded(true);
        });
    } else {
      setSpecGroups([]);
      setSpecValues({});
      setSpecGroupsLoaded(true);
    }
  }, [category]);
  const handleSpecValueChange = (specTitle, value) => {
    setSpecValues((prev) => ({ ...prev, [specTitle]: value }));
  };
  const getMergedSpecGroups = () => {
    const groupMap = {};
    specGroups.forEach((spec) => {
      const name =
        decodeHtmlEntities(spec.groupName?.trim()) || "Uncategorized";
      if (!groupMap[name]) {
        groupMap[name] = {
          groupName: name,
          specs: [],
        };
      }
      groupMap[name].specs.push({
        id: spec.id,
        title: decodeHtmlEntities(spec.title || spec.name || "Untitled"),
        fieldType: spec.fieldType,
        options: decodeHtmlEntities(spec.options),
      });
    });
    return Object.values(groupMap);
  };

  const handleDescriptionImageUpload = (file) => {
    return new Promise((resolve, reject) => {
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp",
        "image/gif",
        "image/bmp",
      ];

      if (!allowedTypes.includes(file.type) || file.size > 21 * 1024) {
        resolve({
          data: {
            link: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
          },
        });
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => resolve({ data: { link: e.target.result } });
      reader.onerror = () => resolve({ data: { link: "" } }); // also silent on read error
      reader.readAsDataURL(file);
    });
  };

  const handleHighlightImageUpload = (file) => {
    return new Promise((resolve, reject) => {
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp",
        "image/gif",
        "image/bmp",
      ];

      if (!allowedTypes.includes(file.type) || file.size > 21 * 1024) {
        resolve({
          data: {
            link: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
          },
        });
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => resolve({ data: { link: e.target.result } });
      reader.onerror = () => resolve({ data: { link: "" } });
      reader.readAsDataURL(file);
    });
  };
  return (
    <>
      <section style={{ backgroundColor: "#F1F4F9" }}>
        {fetchingCategory ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "50vh" }}
          >
            <Spinner color="primary" />
          </div>
        ) : (
          <div className="container-fluid">
            <div className="row">
              {/* Product Preview */}
              <div className="col-lg-3 col-12 mb-4">
                <div
                  className="card p-4"
                  style={{ height: "auto", border: "none" }}
                >
                  <div className="card-body d-flex flex-column align-items-start">
                    {/* Image Preview */}
                    <div
                      className="mb-3"
                      style={{
                        textAlign: "center",
                        width: "100%",
                        height: "auto",
                      }}
                    >
                      <h6 className="card-title fs-5 w-100 text-start">
                        Product Preview
                      </h6>
                      {allImages.length > 1 ? (
                        <div
                          className="position-relative"
                          style={{ width: "190px", height: "190px" }}
                        >
                          <Slider ref={sliderRef} {...settings}>
                            {allImages.map((img, idx) => (
                              <div
                                key={idx}
                                className="d-flex justify-content-center align-items-center"
                              >
                                <img
                                  src={img}
                                  className="img-fluid rounded"
                                  style={{
                                    width: "190px",
                                    height: "190px",
                                    objectFit: "contain",
                                    borderRadius: "8px",
                                  }}
                                />
                              </div>
                            ))}
                          </Slider>
                          <div className="row d-flex justify-content-between">
                            <button
                              type="button"
                              onClick={() => sliderRef.current?.slickPrev()}
                              style={{
                                width: "48px",
                                height: "48px",
                                borderRadius: "50%",
                                backgroundColor: "#0d6efd",
                                color: "white",
                                border: "1px solid #cbd5e1",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                transition: "background-color 0.3s, color 0.3s",
                              }}
                              aria-label="Previous"
                            >
                              <i
                                className="ph ph-caret-left text-xl"
                                style={{ margin: 0, lineHeight: 1 }}
                              />
                            </button>
                            <button
                              type="button"
                              onClick={() => sliderRef.current?.slickNext()}
                              style={{
                                width: "48px",
                                height: "48px",
                                borderRadius: "50%",
                                backgroundColor: "#0d6efd",
                                color: "white",
                                border: "1px solid #cbd5e1",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                transition: "background-color 0.3s, color 0.3s",
                              }}
                              aria-label="Next"
                            >
                              <i
                                className="ph ph-caret-right text-xl"
                                style={{ margin: 0, lineHeight: 1 }}
                              />
                            </button>
                          </div>
                        </div>
                      ) : allImages.length === 1 ? (
                        <>
                          {allImages.map((img, idx) => (
                            <div
                              key={idx}
                              className="d-flex justify-content-center align-items-center"
                            >
                              <img
                                src={img}
                                className="img-fluid rounded"
                                style={{
                                  width: "190px",
                                  height: "190px",
                                  objectFit: "contain",
                                  borderRadius: "8px",
                                }}
                              />
                            </div>
                          ))}
                        </>
                      ) : (
                        <div
                          className="bg-light d-flex justify-content-center align-items-center"
                          style={{
                            width: "190px",
                            height: "190px",
                            borderRadius: "8px",
                          }}
                        >
                          <i
                            className="fa fa-image text-muted"
                            style={{ fontSize: "48px" }}
                          ></i>
                        </div>
                      )}
                    </div>

                    {/* Product Name & Category */}
                    <h6 className="card-title fs-5 w-100 text-start mt-52">
                      {name || "Product Name"}{" "}
                      {category.length > 0 && (
                        <small className="text-muted">
                          (
                          {category
                            .map(
                              (categoryId) =>
                                categoryList.find(
                                  (cat) => cat.id === categoryId,
                                )?.name,
                            )
                            .filter(Boolean)
                            .join(", ") || "Category"}
                          )
                        </small>
                      )}
                    </h6>

                    {/* Price & Delivery */}
                    <p className="card-text text-muted mb-1 w-100 text-start">
                      <strong>Price:</strong> ₹{price || "N/A"}
                    </p>

                    {/* Discount & Warranty */}
                    <p className="card-text text-muted mb-1 w-100 text-start">
                      <strong>B2C Discount:</strong>{" "}
                      {b2cDiscountMode
                        ? `${b2cDiscountValue} (${b2cDiscountMode})`
                        : "N/A"}
                    </p>
                    <p className="card-text text-muted mb-1 w-100 text-start">
                      <strong>B2B Discount:</strong>{" "}
                      {b2bDiscountMode
                        ? `${b2bDiscountValue} (${b2bDiscountMode})`
                        : "N/A"}
                    </p>
                    <p className="card-text text-muted mb-1 w-100 text-start">
                      <strong>Warranty:</strong>{" "}
                      {warrantyMode
                        ? `${warrantyPeriod} ${warrantyMode}`
                        : "N/A"}
                    </p>

                    {/* Description (with HTML support) */}
                    <div className="mt-2 w-100 text-start text-muted">
                      <strong>Description:</strong>
                      <div
                        className="mt-1 p-2 rounded small"
                        style={{ maxHeight: "100px", overflowY: "auto" }}
                        dangerouslySetInnerHTML={{
                          __html:
                            description ||
                            '<p class="text-muted mb-0">No description provided</p>',
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-9">
                <div className="card mb-22 border-0">
                  <div className="d-flex justify-content-between align-items-center p-16">
                    {!readonly && (
                      <h6 className="mb-0 fs-5">
                        {type === EDIT
                          ? "Update Product Image"
                          : "Add Product Image"}
                      </h6>
                    )}
                    {readonly && <h6 className="mb-0 fs-5">Product Image</h6>}
                    {!readonly && (
                      <div className="d-flex align-items-center gap-2">
                        <span className="pe-10">Status</span>
                        <div className="form-check form-switch mb-0">
                          <input
                            className={`form-check-input form-product-status-switch ${
                              status === true ? "switch-green" : "switch-orange"
                            }`}
                            type="checkbox"
                            id="statusSwitch"
                            checked={status}
                            onChange={(e) => setStatus(e.target.checked)}
                          />
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="card-body" style={{ height: "auto" }}>
                    <div
                      className="position-relative"
                      style={{
                        border: "2px dashed #ccc",
                        borderRadius: "8px",
                        transition: "border-color 0.2s",
                        minHeight: "270px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        padding: "1rem",
                        background: "#fff",
                      }}
                      onClick={() => mainImageElement.current?.click()}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.borderColor = "#0d6efd")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.borderColor =
                          mainImageError || extraImagesError
                            ? "#dc3545"
                            : "#ccc")
                      }
                    >
                      {/* Main Image Preview or Upload Prompt */}
                      {mainImagePreview ? (
                        <div className="d-flex flex-column align-items-center w-100">
                          <img
                            src={mainImagePreview}
                            alt="Main"
                            className="img-fluid mb-2"
                            style={{ maxHeight: "180px", objectFit: "contain" }}
                          />
                          <small className="text-muted">
                            Main product image
                          </small>
                        </div>
                      ) : (
                        <>
                          <i
                            className="fa fa-cloud-upload-alt mb-2"
                            style={{ fontSize: "48px", color: "#0d6efd" }}
                          ></i>
                          <h6 className="mb-1">
                            Drop your images here, or{" "}
                            <span
                              className="text-primary"
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                mainImageElement.current?.click();
                              }}
                            >
                              click to browse
                            </span>
                          </h6>
                          <small className="text-muted text-center px-2">
                            Square pixels recommended. PNG, JPG, WebP allowed.
                          </small>
                        </>
                      )}

                      {/* Hidden file input for main image */}
                      <input
                        type="file"
                        name="image"
                        onChange={(e) => handleMainImage(e.target.files)}
                        className="d-none"
                        accept="image/*"
                        ref={mainImageElement}
                        disabled={readonly}
                      />

                      {/* Error message for main image */}
                      {mainImageError && (
                        <span className="text-danger fw-bold small mt-2">
                          {mainImageError}
                        </span>
                      )}
                    </div>

                    {/* Add More Images Section (below the main upload area) */}
                    {!readonly && (
                      <div
                        className="mt-3 d-flex flex-column align-items-center"
                        onClick={(e) => {
                          e.stopPropagation();
                          extraImagesElement.current?.click();
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <button
                          type="button"
                          className="w-100 d-flex align-items-center gap-2"
                          style={{
                            background: "transparent",
                            backgroundColor: "#bed9f8ff",
                            borderRadius: "6px",
                            color: "#0d6efd",
                            fontSize: "14px",
                            fontWeight: "500",
                            cursor: "pointer",
                            transition: "all 0.2s",
                            textAlign: "center",
                            justifyContent: "center",
                            marginTop: "20px",
                            paddingTop: "10px",
                            paddingBottom: "10px",
                          }}
                          disabled={readonly}
                          onClick={(e) => {
                            e.stopPropagation();
                            extraImagesElement.current?.click();
                          }}
                        >
                          <i
                            className="fa fa-plus mt-2"
                            style={{ fontSize: "18px" }}
                          ></i>
                          <h6
                            className="ps-8 m-0 fs-6"
                            style={{ color: "#0d6efd" }}
                          >
                            {" "}
                            Add More Images
                          </h6>
                        </button>
                        <input
                          type="file"
                          name="extraImage"
                          onChange={(e) => handleExtraImages(e.target.files)}
                          className="d-none"
                          accept="image/*"
                          ref={extraImagesElement}
                          disabled={readonly}
                          multiple
                        />
                      </div>
                    )}

                    {/* Extra Images Error */}
                    {extraImagesError && (
                      <span className="text-danger fw-bold small d-block mt-1">
                        {extraImagesError}
                      </span>
                    )}

                    {/* Extra Images Previews */}
                    <div className="row mt-2 w-100">
                      {extraImages.map((image, index) => {
                        let previewUrl = "";
                        if (image instanceof File) {
                          previewUrl = URL.createObjectURL(image);
                        } else if (image.imageUrl) {
                          previewUrl = image.imageUrl;
                        } else {
                          return null;
                        }
                        return (
                          <ExtraImage
                            key={image.id || `new-${index}`}
                            src={previewUrl}
                            onClose={() => removeExtraImage(image)}
                            readOnly={readonly}
                          />
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div className="card mb-22 border-0" style={{ height: "auto" }}>
                  <div className="d-flex justify-content-between align-items-center pe-16 ps-16 pt-16">
                    <h6 className="mb-0 fs-5">Select Category</h6>
                    {!readonly && (
                      <button
                        onClick={clearcategory}
                        disabled={readonly}
                        style={{
                          backgroundColor: "#bed9f8ff",
                          color: "#1976d2",
                          border: "none",
                          padding: "8px 20px",
                          fontWeight: "500",
                          borderRadius: "5px",
                        }}
                      >
                        Clear
                      </button>
                    )}
                  </div>
                  <div
                    className="row text-center ms-16 me-16 mt-16 mb-40 p-16"
                    style={{
                      backgroundColor: "#F1F4F9",
                      height: "auto",
                      borderRadius: "6px",
                    }}
                  >
                    {categoryList
                      .filter((f) => String(f.parentId) !== "-1")
                      .map((cat) => {
                        const isSelected = cat.id === category;
                        console.log("isSelected", isSelected);

                        return (
                          <Category
                            key={cat.id}
                            name={cat.name}
                            onSelect={() => handleCategory(cat.id)}
                            isSelected={isSelected}
                            readOnly={readonly}
                          />
                        );
                      })}
                    <span className="text-danger my-2 small fw-bold">
                      {categoryError}
                    </span>
                  </div>
                </div>
                <div className="card mb-22 border-0" style={{ height: "auto" }}>
                  <div className="d-flex justify-content-between align-items-center pe-16 ps-16 pt-16">
                    <h6 className="mb-0 fs-5">Select Brand</h6>
                    {!readonly && (
                      <button
                        onClick={clearbrand}
                        disabled={readonly}
                        style={{
                          backgroundColor: "#bed9f8ff",
                          color: "#1976d2",
                          border: "none",
                          padding: "8px 20px",
                          fontWeight: "500",
                          borderRadius: "5px",
                        }}
                      >
                        Clear
                      </button>
                    )}
                  </div>
                  <div
                    className="row text-center ms-16 me-16 mt-16 mb-40 p-16"
                    style={{
                      backgroundColor: "#F1F4F9",
                      height: "auto",
                      borderRadius: "6px",
                    }}
                  >
                    <div className="col-12">
                      <div className="row">
                        {brands?.map((brandItem) => {
                          const isSelected = brandItem.id === brand;

                          return (
                            <div
                              className="col-12 col-sm-6 col-md-4 col-lg-3 mb-2"
                              key={brandItem.id}
                            >
                              <label
                                className={`d-flex align-items-center cursor-pointer`}
                                htmlFor={`brand-${brandItem.id}`}
                              >
                                <input
                                  type="radio"
                                  name="brand"
                                  id={`brand-${brandItem.id}`}
                                  className="form-check-input me-5"
                                  checked={isSelected}
                                  onChange={() => handleBrand(brandItem.id)}
                                  disabled={readonly}
                                />
                                <span>{brandItem.name}</span>
                              </label>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card mb-22 border-0" style={{ height: "auto" }}>
                  <div className="d-flex justify-content-between align-items-center pe-16 ps-16 pt-16">
                    <h6 className="mb-0 fs-5">Select Grade</h6>
                    {!readonly && (
                      <button
                        onClick={clearGrade}
                        disabled={readonly}
                        style={{
                          backgroundColor: "#bed9f8ff",
                          color: "#1976d2",
                          border: "none",
                          padding: "8px 20px",
                          fontWeight: "500",
                          borderRadius: "5px",
                        }}
                      >
                        Clear
                      </button>
                    )}
                  </div>
                  <div
                    className="row text-center ms-16 me-16 mt-16 mb-40 p-16"
                    style={{
                      backgroundColor: "#F1F4F9",
                      height: "auto",
                      borderRadius: "6px",
                    }}
                  >
                    {/* Check if category is ("Steel"||"Steels") */}
                    {categoryList.find((cat) => cat.id === category)?.name ===
                    ("Steel" || "Steels") ? (
                      // Show Radio Buttons for Steel Grades
                      <div className="col-12">
                        <div className="row">
                          {STEEL_GRADES.map((gradeOption, index) => (
                            <div
                              className="col-12 col-sm-6 col-md-4 col-lg-3 mb-2"
                              key={gradeOption.value}
                            >
                              <label
                                className={`d-flex align-items-center cursor-pointer`}
                                htmlFor={`steel-grade-${index}`}
                              >
                                <input
                                  type="radio"
                                  name="steelGrade"
                                  id={`steel-grade-${index}`}
                                  className="form-check-input me-5"
                                  checked={grade === gradeOption.value}
                                  onChange={() => {
                                    setGrade(gradeOption.value);
                                    setTypeGrade("");
                                    setCertification("");
                                  }}
                                  disabled={readonly}
                                />
                                <span>{gradeOption.label}</span>
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <div className="col-12">
                        <div className="row">
                          <div className="col-md-4 mt-0 pt-0">
                            <h6
                              htmlFor="typeGrade"
                              className="text-md mb-16 fw-bold text-start"
                            >
                              Type
                            </h6>
                            <input
                              type="text"
                              className={`form-control ${
                                typeGradeError !== "" && "border-danger"
                              }`}
                              placeholder="Enter the type"
                              id="typeGrade"
                              required
                              onChange={(e) => handleTypeGrade(e.target.value)}
                              value={typeGrade}
                              style={{
                                bordeRadius: " 5px",
                                fontWeight: " 400",
                                outline: " none",
                                width: " 100%",
                                padding: " 11px 24px",
                                backgroundColor: " transparent !important",
                                border: " 1px solid var(--gray-100)",
                                color: " hsl(var(--black))",
                              }}
                              disabled={readonly}
                            />
                            <span className="text-danger my-2 small fw-bold">
                              {typeGradeError}
                            </span>
                            <br />
                          </div>
                          <div className="col-md-4 mt-0 pt-0">
                            <h6
                              htmlFor="grade"
                              className="text-md mb-16 fw-bold text-start"
                            >
                              Grade
                            </h6>
                            <input
                              type="text"
                              className={`form-control ${
                                gradeError !== "" && "border-danger"
                              }`}
                              placeholder="Enter Grade"
                              id="grade"
                              required
                              onChange={(e) => handleGrade(e.target.value)}
                              value={grade}
                              style={{
                                bordeRadius: " 5px",
                                fontWeight: " 400",
                                outline: " none",
                                width: " 100%",
                                padding: " 11px 24px",
                                backgroundColor: " transparent !important",
                                border: " 1px solid var(--gray-100)",
                                color: " hsl(var(--black))",
                              }}
                              disabled={readonly}
                            />
                            <span className="text-danger my-2 small fw-bold">
                              {gradeError}
                            </span>
                            <br />
                          </div>
                          <div className="col-md-4 mt-0 pt-0">
                            <h6
                              htmlFor="certification"
                              className="text-md mb-16 fw-bold text-start"
                            >
                              IS Certification
                            </h6>
                            <input
                              type="text"
                              className={`form-control ${
                                certificationError !== "" && "border-danger"
                              }`}
                              placeholder="Enter IS Certification"
                              id="certification"
                              required
                              onChange={(e) =>
                                handleCertification(e.target.value)
                              }
                              value={certification}
                              style={{
                                bordeRadius: " 5px",
                                fontWeight: " 400",
                                outline: " none",
                                width: " 100%",
                                padding: " 11px 24px",
                                backgroundColor: " transparent !important",
                                border: " 1px solid var(--gray-100)",
                                color: " hsl(var(--black))",
                              }}
                              disabled={readonly}
                            />
                            <span className="text-danger my-2 small fw-bold">
                              {certificationError}
                            </span>
                            <br />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="card mb-22 border-0" style={{ height: "auto" }}>
                  <div className="d-flex justify-content-between align-items-center pe-16 ps-16 pt-16">
                    <h6 className="mb-0 fs-5">Product Information</h6>
                    {!readonly && (
                      <button
                        onClick={clearProductInformation}
                        disabled={readonly}
                        style={{
                          backgroundColor: "#bed9f8ff",
                          color: "#1976d2",
                          border: "none",
                          padding: "8px 20px",
                          fontWeight: "500",
                          borderRadius: "5px",
                        }}
                      >
                        Clear
                      </button>
                    )}
                  </div>
                  <div
                    className="row text-center mt-16 ps-16"
                    style={{ height: "auto" }}
                  >
                    <div className="row">
                      <div className="col-md-6">
                        <h6
                          htmlFor="name"
                          className="text-md mb-16 fw-bold text-start"
                        >
                          Product Name
                        </h6>
                        <input
                          type="text"
                          className={`form-control ${
                            nameError !== "" && "border-danger"
                          }`}
                          placeholder="Name"
                          id="name"
                          required
                          autoComplete="off"
                          onChange={(e) => handleName(e.target.value)}
                          value={name}
                          style={{
                            bordeRadius: " 5px",
                            fontWeight: " 400",
                            outline: " none",
                            width: " 100%",
                            padding: " 11px 24px",
                            backgroundColor: " transparent !important",
                            border: " 1px solid var(--gray-100)",
                            color: " hsl(var(--black))",
                          }}
                          disabled={readonly}
                        />
                        <span className="text-danger my-2 small fw-bold">
                          {nameError}
                        </span>
                        <br />
                      </div>

                      <div className="col-md-6">
                        <h6 className="text-md mb-16 fw-bold text-start">
                          Select Warranty Mode
                        </h6>
                        <div
                          className="d-flex flex-wrap gap-3"
                          style={{ justifyContent: "flex-start" }}
                        >
                          <div className="form-check me-16 mt-12">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="warrantyMode"
                              id="month"
                              checked={warrantyMode === "month"}
                              onChange={() => handleWarrantyMode("month")}
                              disabled={readonly}
                            />
                            <label className="form-check-label" htmlFor="month">
                              Month
                            </label>
                          </div>
                          <div className="form-check mt-12">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="warrantyMode"
                              id="year"
                              checked={warrantyMode === "year"}
                              onChange={() => handleWarrantyMode("year")}
                              disabled={readonly}
                            />
                            <label className="form-check-label" htmlFor="year">
                              Year
                            </label>
                          </div>
                        </div>
                        <div className="text-danger my-2 small fw-bold">
                          {warrantyModeError}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <h6
                          htmlFor="warrantyPeriod"
                          className="text-md mb-16 fw-bold text-start"
                        >
                          Warranty Period
                        </h6>
                        <input
                          type="number"
                          className={`form-control ${
                            warrantyPeriodError !== "" && "border-danger"
                          }`}
                          placeholder="Warranty Period"
                          id="warrantyPeriod"
                          required
                          autoComplete="off"
                          onFocus={(e) => preventWheel(e)}
                          onKeyDown={(e) => preventArrow(e)}
                          onChange={(e) => handleWarrantyPeriod(e.target.value)}
                          value={warrantyPeriod}
                          style={{
                            bordeRadius: " 5px",
                            fontWeight: " 400",
                            outline: " none",
                            width: " 100%",
                            padding: " 11px 24px",
                            backgroundColor: " transparent !important",
                            border: " 1px solid var(--gray-100)",
                            color: " hsl(var(--black))",
                          }}
                          disabled={readonly}
                        />
                        <span className="text-danger my-2 small fw-bold">
                          {warrantyPeriodError}
                        </span>
                        <br />
                      </div>
                      <div className="col-md-6">
                        <h6
                          htmlFor="warrantyLabel"
                          className="text-md mb-16 fw-bold text-start"
                        >
                          Warranty Label
                        </h6>
                        <input
                          type="text"
                          className={`form-control ${
                            warrantyLabelError !== "" && "border-danger"
                          }`}
                          placeholder="Warranty Label"
                          id="warrantyLabel"
                          required
                          autoComplete="off"
                          onChange={(e) => handleWarrantyLabel(e.target.value)}
                          value={warrantyLabel}
                          style={{
                            bordeRadius: " 5px",
                            fontWeight: " 400",
                            outline: " none",
                            width: " 100%",
                            padding: " 11px 24px",
                            backgroundColor: " transparent !important",
                            border: " 1px solid var(--gray-100)",
                            color: " hsl(var(--black))",
                          }}
                          disabled={readonly}
                        />
                        <span className="text-danger my-2 small fw-bold">
                          {warrantyLabelError}
                        </span>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
                {categoryList.find((cat) => cat.id === category)?.name ===
                ("Steel" || "Steels") ? (
                  <div
                    className="card mb-22 border-0"
                    style={{ height: "auto" }}
                  >
                    <div className="d-flex justify-content-between align-items-center pe-16 ps-16 pt-16 ">
                      <h6 className="mb-0 fs-5 ms-16">Price Details</h6>
                      {!readonly && (
                        <button
                          onClick={clearPrice}
                          disabled={readonly}
                          style={{
                            backgroundColor: "#bed9f8ff",
                            color: "#1976d2",
                            border: "none",
                            padding: "8px 20px",
                            fontWeight: "500",
                            borderRadius: "5px",
                          }}
                        >
                          Clear
                        </button>
                      )}
                    </div>
                    <div className="row text-center pt-32 ps-16 pe-16 pb-16">
                      <div className="row">
                        <div className="col-md-12 mb-16 ms-16">
                          <h6 className="text-md fw-bold text-start">
                            Show This Product to{" "}
                            <input
                              type="checkbox"
                              className="ms-5 me-5"
                              checked={showB2C}
                              onChange={(e) => {
                                if (!e.target.checked && !showB2B) return; // prevent unchecking last
                                setShowB2C(e.target.checked);
                              }}
                              disabled={readonly}
                            />
                            B2C
                          </h6>
                        </div>
                      </div>
                      <div className="text-center ps-16 pe-16 pb-16">
                        <div className="border border-gray rounded-5">
                          <div className="row mt-16 ms-16 me-16">
                            <div className="d-flex justify-content-between align-items-center pe-16 pb-0 mb-16 ">
                              <h6 className="mb-0 fs-5">B2C Price Details</h6>
                            </div>
                            <div className="row">
                              <div className="col-3">
                                <h6 className="text-md mb-0 fw-bold text-start">
                                  Diameter
                                </h6>
                              </div>
                              <div className="col-2">
                                <h6 className="text-md mb-0 fw-bold text-start">
                                  Retail Price / kg
                                </h6>
                              </div>
                              <div className="col-3">
                                <h6 className="text-md mb-0 fw-bold text-start">
                                  Discount Mode
                                </h6>
                              </div>
                              <div className="col-2">
                                <h6 className="text-md mb-0 fw-bold text-start">
                                  Selling Price / kg
                                </h6>
                              </div>

                              <div className="col-2">
                                <h6 className="text-md mb-0 fw-bold text-start">
                                  Discount Value
                                </h6>
                              </div>
                            </div>
                            {steelB2CPrices.map((item, index) => (
                              <div key={index} className="row mt-16 mb-16">
                                <div className="col-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={item.diameter}
                                    readOnly
                                    style={inputStyle}
                                    disabled={readonly}
                                  />
                                </div>
                                <div className="col-2">
                                  <CustomNumberInput
                                    className="form-control"
                                    value={item.retailPrice}
                                    onChange={(val) => {
                                      const retail = val;
                                      const selling = item.sellingPrice;
                                      const mode = item.discountMode;
                                      const discValue = calculateDiscountValue(
                                        retail,
                                        selling,
                                        mode,
                                      );
                                      const newPrices = [...steelB2CPrices];
                                      newPrices[index] = {
                                        ...newPrices[index],
                                        retailPrice: retail,
                                        discountValue: discValue || "",
                                      };
                                      setSteelB2CPrices(newPrices);
                                    }}
                                    disabled={!showB2C || readonly}
                                    style={inputStyle}
                                    step="any"
                                  />
                                </div>
                                <div className="col-3">
                                  <select
                                    className="form-select"
                                    value={item.discountMode}
                                    onChange={(e) => {
                                      const mode = e.target.value;
                                      const retail = item.retailPrice;
                                      const selling = item.sellingPrice;
                                      const discValue = calculateDiscountValue(
                                        retail,
                                        selling,
                                        mode,
                                      );
                                      const newPrices = [...steelB2CPrices];
                                      newPrices[index] = {
                                        ...newPrices[index],
                                        discountMode: mode,
                                        discountValue: discValue || "",
                                      };
                                      setSteelB2CPrices(newPrices);
                                    }}
                                    disabled={!showB2C || readonly}
                                    style={inputStyle}
                                  >
                                    <option value="">--Select Mode--</option>
                                    <option value="amount">Amount</option>
                                    <option value="percent">Percent</option>
                                  </select>
                                </div>
                                <div className="col-2">
                                  <CustomNumberInput
                                    className="form-control"
                                    value={item.sellingPrice}
                                    // Inside steelB2CPrices.map — Selling Price input onChange
                                    onChange={(val) => {
                                      const selling = val;
                                      const retail = item.retailPrice;
                                      const mode = item.discountMode;
                                      const discValue = calculateDiscountValue(
                                        retail,
                                        selling,
                                        mode,
                                      );

                                      // Also update B2B rateValue for the same index
                                      const b2bItem = steelB2BPrices[index];
                                      const newRateValue = b2bItem?.priceDiff
                                        ? recalculateRateValueForIndex(
                                            selling,
                                            b2bItem.sellingPrice || "",
                                            b2bItem.priceDiff,
                                          )
                                        : b2bItem?.rateValue || "";

                                      const newPrices = [...steelB2CPrices];
                                      newPrices[index] = {
                                        ...newPrices[index],
                                        sellingPrice: selling,
                                        discountValue: discValue || "",
                                      };
                                      setSteelB2CPrices(newPrices);

                                      // Update B2B rateValue without changing other fields
                                      if (b2bItem) {
                                        setSteelB2BPrices((prev) => {
                                          const updated = [...prev];
                                          updated[index] = {
                                            ...updated[index],
                                            rateValue: newRateValue,
                                          };
                                          return updated;
                                        });
                                      }
                                    }}
                                    disabled={!showB2C || readonly}
                                    style={inputStyle}
                                    step="any"
                                  />
                                </div>

                                <div className="col-2">
                                  <input
                                    type="number"
                                    className="form-control"
                                    value={item.discountValue}
                                    readOnly
                                    style={{
                                      ...inputStyle,
                                      backgroundColor: "#f5f5f5",
                                      cursor: "not-allowed",
                                    }}
                                    disabled={readonly}
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 mb-16 ms-16 mt-32">
                          <h6 className="text-md fw-bold text-start">
                            Show This Product to{" "}
                            <input
                              type="checkbox"
                              className="ms-5 me-5"
                              checked={showB2B}
                              onChange={(e) => {
                                if (!e.target.checked && !showB2C) return;
                                setShowB2B(e.target.checked);
                              }}
                              disabled={readonly}
                            />
                            B2B
                          </h6>
                        </div>
                      </div>
                      <div className="text-center ps-16 pe-16 pb-16">
                        <div className="border border-gray rounded-5">
                          {/* Scrollable container */}
                          <div
                            className="table-responsive"
                            style={{
                              overflowX: "auto",
                              padding: "16px",
                              overflowY: "auto",
                            }}
                          >
                            <div style={{ minWidth: "1000px" }}>
                              {/* Header Row */}
                              <div
                                style={{
                                  display: "flex",
                                  fontWeight: "bold",
                                  marginBottom: "12px",
                                }}
                              >
                                <div
                                  style={{ width: "130px", padding: "0 8px" }}
                                >
                                  Diameter
                                </div>
                                <div
                                  style={{ width: "150px", padding: "0 8px" }}
                                >
                                  Retail Price / kg
                                </div>
                                <div
                                  style={{ width: "190px", padding: "0 8px" }}
                                >
                                  Discount Mode
                                </div>
                                <div
                                  style={{ width: "150px", padding: "0 8px" }}
                                >
                                  Selling Price / kg
                                </div>

                                <div
                                  style={{ width: "140px", padding: "0 8px" }}
                                >
                                  Discount Value
                                </div>
                                <div
                                  style={{ width: "190px", padding: "0 8px" }}
                                >
                                  Price Differ.
                                </div>
                                <div
                                  style={{ width: "160px", padding: "0 8px" }}
                                >
                                  Rate Value
                                </div>
                              </div>

                              {/* Data Rows */}
                              {steelB2BPrices.map((item, index) => (
                                <div
                                  key={index}
                                  style={{
                                    display: "flex",
                                    marginBottom: "12px",
                                  }}
                                >
                                  {/* Diameter */}
                                  <div
                                    style={{ width: "130px", padding: "0 8px" }}
                                  >
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={item.diameter}
                                      readOnly
                                      disabled={readonly}
                                      style={inputStyle}
                                    />
                                  </div>

                                  {/* Retail Price */}
                                  <div
                                    style={{ width: "150px", padding: "0 8px" }}
                                  >
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={
                                        steelB2CPrices[index]?.retailPrice || ""
                                      }
                                      readOnly
                                      disabled={!showB2B || readonly}
                                      style={inputStyle}
                                      step="any"
                                    />
                                  </div>

                                  {/* Discount Mode */}
                                  <div
                                    style={{ width: "190px", padding: "0 8px" }}
                                  >
                                    <select
                                      className="form-select"
                                      value={item.discountMode}
                                      onChange={(e) => {
                                        const mode = e.target.value;
                                        const retail =
                                          steelB2CPrices[index]?.retailPrice ||
                                          item.retailPrice;
                                        const selling = item.sellingPrice;
                                        const discValue =
                                          calculateDiscountValue(
                                            retail,
                                            selling,
                                            mode,
                                          );
                                        const newPrices = [...steelB2BPrices];
                                        newPrices[index] = {
                                          ...newPrices[index],
                                          discountMode: mode,
                                          discountValue: discValue || "",
                                        };
                                        setSteelB2BPrices(newPrices);
                                      }}
                                      disabled={!showB2B || readonly}
                                      style={inputStyle}
                                    >
                                      <option value="">--Select Mode--</option>
                                      <option value="amount">Amount</option>
                                      <option value="percent">Percent</option>
                                    </select>
                                  </div>

                                  {/* Selling Price */}
                                  <div
                                    style={{ width: "150px", padding: "0 8px" }}
                                  >
                                    <CustomNumberInput
                                      className="form-control"
                                      value={item.sellingPrice}
                                      // Inside steelB2BPrices.map — Selling Price input onChange
                                      onChange={(val) => {
                                        const selling = val;
                                        const retail =
                                          steelB2CPrices[index]?.retailPrice ||
                                          item.retailPrice;
                                        const mode = item.discountMode;
                                        const discValue =
                                          calculateDiscountValue(
                                            retail,
                                            selling,
                                            mode,
                                          );

                                        // Recalculate rateValue using current B2C selling price
                                        const b2cSelling =
                                          steelB2CPrices[index]?.sellingPrice ||
                                          "";
                                        const newRateValue = item.priceDiff
                                          ? recalculateRateValueForIndex(
                                              b2cSelling,
                                              selling,
                                              item.priceDiff,
                                            )
                                          : item.rateValue || "";

                                        const newPrices = [...steelB2BPrices];
                                        newPrices[index] = {
                                          ...newPrices[index],
                                          sellingPrice: selling,
                                          discountValue: discValue || "",
                                          rateValue: newRateValue,
                                        };
                                        setSteelB2BPrices(newPrices);
                                      }}
                                      disabled={!showB2B || readonly}
                                      style={inputStyle}
                                      step="any"
                                    />
                                  </div>
                                  {/* Discount Value */}
                                  <div
                                    style={{ width: "140px", padding: "0 8px" }}
                                  >
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={item.discountValue}
                                      readOnly
                                      disabled={readonly}
                                      style={{
                                        ...inputStyle,
                                        backgroundColor: "#f5f5f5",
                                        cursor: "not-allowed",
                                      }}
                                    />
                                  </div>
                                  {/* Price Difference Mode */}
                                  <div
                                    style={{ width: "190px", padding: "0 8px" }}
                                  >
                                    <select
                                      className="form-select"
                                      value={item.priceDiff}
                                      // Inside steelB2BPrices.map — Price Difference Mode onChange
                                      onChange={(e) => {
                                        const mode = e.target.value;
                                        const b2cSelling =
                                          steelB2CPrices[index]?.sellingPrice ||
                                          "";
                                        const b2bSelling =
                                          item.sellingPrice || "";
                                        const rateVal =
                                          recalculateRateValueForIndex(
                                            b2cSelling,
                                            b2bSelling,
                                            mode,
                                          );

                                        const newPrices = [...steelB2BPrices];
                                        newPrices[index] = {
                                          ...newPrices[index],
                                          priceDiff: mode,
                                          rateValue: rateVal || "",
                                        };
                                        setSteelB2BPrices(newPrices);
                                      }}
                                      disabled={!showB2B || readonly}
                                      style={inputStyle}
                                    >
                                      <option value="">--Select--</option>
                                      <option value="amount">Amount</option>
                                      <option value="percent">Percent</option>
                                    </select>
                                  </div>

                                  {/* Rate Value */}
                                  <div
                                    style={{ width: "140px", padding: "0 8px" }}
                                  >
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={item.rateValue}
                                      readOnly
                                      disabled={!showB2B || readonly}
                                      style={{
                                        ...inputStyle,
                                        backgroundColor: "#f5f5f5",
                                        cursor: "not-allowed",
                                      }}
                                    />
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 mb-16 ms-16 mt-32">
                          <h6 className="text-md fw-bold text-start">
                            <input
                              type="checkbox"
                              className="me-5"
                              disabled={readonly}
                            />{" "}
                            Include Tax
                          </h6>
                        </div>
                      </div>
                      <div className="text-center ps-16 pe-16 pb-16">
                        <div className="border border-gray rounded-5">
                          <div className="row mt-16 ms-16 me-16">
                            <div className="d-flex justify-content-between align-items-center pe-16 pb-0 mb-16 ">
                              <h6 className="mb-0 fs-5">Tax Details</h6>
                            </div>
                            <div className="col-md-4 mt-0 pt-0">
                              <h6
                                htmlFor="tax"
                                className="text-md mb-16 fw-bold text-start"
                              >
                                Tax (%)
                              </h6>
                              <CustomNumberInput
                                className={`form-control ${
                                  taxError !== "" && "border-danger"
                                }`}
                                placeholder="Enter percentage"
                                id="tax"
                                required
                                onChange={handleTax}
                                value={tax}
                                style={{
                                  bordeRadius: " 5px",
                                  fontWeight: " 400",
                                  outline: " none",
                                  width: " 100%",
                                  padding: " 11px 24px",
                                  backgroundColor: " transparent !important",
                                  border: " 1px solid var(--gray-100)",
                                  color: " hsl(var(--black))",
                                }}
                              />
                              <span className="text-danger my-2 small fw-bold">
                                {taxError}
                              </span>
                              <br />
                            </div>
                            <div className="col-md-4 mt-0 pt-0">
                              <h6
                                htmlFor="cgst"
                                className="text-md mb-16 fw-bold text-start"
                              >
                                CGST (%)
                              </h6>
                              <CustomNumberInput
                                className={`form-control ${
                                  cgstError !== "" && "border-danger"
                                }`}
                                placeholder="Enter percentage"
                                id="cgst"
                                required
                                onChange={handleCgst}
                                value={cgst}
                                style={{
                                  bordeRadius: " 5px",
                                  fontWeight: " 400",
                                  outline: " none",
                                  width: " 100%",
                                  padding: " 11px 24px",
                                  backgroundColor: " transparent !important",
                                  border: " 1px solid var(--gray-100)",
                                  color: " hsl(var(--black))",
                                }}
                              />
                              <span className="text-danger my-2 small fw-bold">
                                {cgstError}
                              </span>
                              <br />
                            </div>
                            <div className="col-md-4 mt-0 pt-0">
                              <h6
                                htmlFor="sgst"
                                className="text-md mb-16 fw-bold text-start"
                              >
                                SGST (%)
                              </h6>
                              <CustomNumberInput
                                className={`form-control ${
                                  sgstError !== "" && "border-danger"
                                }`}
                                placeholder="Enter percentage"
                                id="sgst"
                                required
                                onChange={handleSgst}
                                value={sgst}
                                style={{
                                  bordeRadius: " 5px",
                                  fontWeight: " 400",
                                  outline: " none",
                                  width: " 100%",
                                  padding: " 11px 24px",
                                  backgroundColor: " transparent !important",
                                  border: " 1px solid var(--gray-100)",
                                  color: " hsl(var(--black))",
                                }}
                              />
                              <span className="text-danger my-2 small fw-bold">
                                {sgstError}
                              </span>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    className="card mb-22 border-0"
                    style={{ height: "auto" }}
                  >
                    <div className="d-flex justify-content-between align-items-center pe-16 ps-16 pt-16 ">
                      <h6 className="mb-0 fs-5 ms-16">Price Details</h6>
                      {!readonly && (
                        <button
                          onClick={clearPrice}
                          disabled={readonly}
                          style={{
                            backgroundColor: "#bed9f8ff",
                            color: "#1976d2",
                            border: "none",
                            padding: "8px 20px",
                            fontWeight: "500",
                            borderRadius: "5px",
                          }}
                        >
                          Clear
                        </button>
                      )}
                    </div>
                    <div className="row text-center pt-32 ps-16 pe-16 pb-16">
                      <div className="row">
                        <div className="col-md-6 mt-0 pt-0">
                          <h6
                            htmlFor="price"
                            className="text-md ms-16 mb-16 fw-bold text-start"
                          >
                            Retail price
                          </h6>
                          <CustomNumberInput
                            className={`form-control ${
                              priceError !== "" && "border-danger"
                            } ms-16`}
                            placeholder="Enter Retail Price"
                            id="price"
                            required
                            onChange={handlePrice}
                            value={price}
                            style={{
                              bordeRadius: " 5px",
                              fontWeight: " 400",
                              outline: " none",
                              width: " 100%",
                              padding: " 11px 24px",
                              backgroundColor: " transparent !important",
                              border: " 1px solid var(--gray-100)",
                              color: " hsl(var(--black))",
                            }}
                            disabled={readonly}
                          />
                          <span className="text-danger my-2 small fw-bold">
                            {priceError}
                          </span>
                          <br />
                        </div>
                        {/* NEW WEIGHT FIELD */}
                        <div className="col-md-6 mt-0 pt-0">
                          <h6
                            htmlFor="weight"
                            className="text-md ms-16 mb-16 fw-bold text-start"
                          >
                            Weight (kg)
                          </h6>
                          <CustomNumberInput
                            className={`form-control ${
                              weightError !== "" && "border-danger"
                            } ms-16`}
                            placeholder="Enter Weight"
                            id="weight"
                            onChange={handleWeight}
                            value={weight}
                            style={{
                              bordeRadius: " 5px",
                              fontWeight: " 400",
                              outline: " none",
                              width: " 100%",
                              padding: " 11px 24px",
                              backgroundColor: " transparent !important",
                              border: " 1px solid var(--gray-100)",
                              color: " hsl(var(--black))",
                            }}
                            disabled={readonly}
                          />
                          <span className="text-danger my-2 small fw-bold">
                            {weightError}
                          </span>
                          <br />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 mb-16 ms-16">
                          <h6 className="text-md fw-bold text-start">
                            Show This Product to{" "}
                            <input
                              type="checkbox"
                              className="ms-5 me-5"
                              checked={showB2C}
                              onChange={(e) => {
                                if (!e.target.checked && !showB2B) return; // prevent unchecking last
                                setShowB2C(e.target.checked);
                              }}
                              disabled={readonly}
                            />
                            B2C
                          </h6>
                        </div>
                      </div>
                      <div className="text-center ps-16 pe-16 pb-16">
                        <div className="border border-gray rounded-5">
                          <div className="row mt-16 ms-16 me-16">
                            <div className="d-flex justify-content-between align-items-center pe-16 pb-0 mb-16 ">
                              <h6 className="mb-0 fs-5">B2C Price Details</h6>
                            </div>
                            <div className="row">
                              {/* Selling Price Input */}
                              <div className="col-md-6 mt-0 pt-0">
                                <h6
                                  htmlFor="discountMode"
                                  className="text-md mb-16 fw-bold text-start"
                                >
                                  Discount Mode
                                </h6>
                                <select
                                  id="discountMode"
                                  className={`form-select ${
                                    b2cDiscountModeError !== ""
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  value={b2cDiscountMode}
                                  onChange={(e) =>
                                    handleB2cDiscountMode(e.target.value)
                                  }
                                  disabled={!showB2C || readonly}
                                  style={{
                                    borderRadius: "5px",
                                    fontWeight: "400",
                                    outline: "none",
                                    width: "100%",
                                    padding: "11px 24px",
                                    backgroundColor: "transparent !important",
                                    border: "1px solid var(--gray-100)",
                                    color: "hsl(var(--black))",
                                  }}
                                  required
                                >
                                  <option value="">--Select Mode--</option>
                                  <option value="amount">Amount</option>
                                  <option value="percent">Percent</option>
                                </select>
                                <span className="text-danger my-2 small fw-bold">
                                  {b2cDiscountModeError}
                                </span>
                                <br />
                              </div>

                              <div className="col-md-6 mt-0 pt-0">
                                <h6 className="text-md mb-16 fw-bold text-start">
                                  Selling price
                                </h6>
                                <CustomNumberInput
                                  type="number"
                                  className="form-control"
                                  value={sellingPriceB2CInput}
                                  onChange={handleSellingPriceB2CInput}
                                  disabled={!showB2C || readonly}
                                  style={inputStyle}
                                />
                              </div>
                            </div>
                            <div className="col-md-6 mt-0 pt-0">
                              <h6 className="text-md mb-16 fw-bold text-start">
                                Discount Value
                              </h6>
                              <input
                                type="number"
                                className={`form-control ${
                                  b2cDiscountValueError !== "" &&
                                  "border-danger"
                                }`}
                                value={b2cDiscountValue}
                                readOnly
                                style={{
                                  ...inputStyle,
                                  backgroundColor: "#fff",
                                  cursor: "not-allowed",
                                }}
                                disabled={readonly}
                              />
                              <span className="text-danger my-2 small fw-bold">
                                {b2cDiscountValueError}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12 mb-16 ms-16 mt-32">
                          <h6 className="text-md fw-bold text-start">
                            Show This Product to{" "}
                            <input
                              type="checkbox"
                              className="ms-5 me-5"
                              checked={showB2B}
                              onChange={(e) => {
                                if (!e.target.checked && !showB2C) return; // prevent unchecking last
                                setShowB2B(e.target.checked);
                              }}
                              disabled={readonly}
                            />
                            B2B
                          </h6>
                        </div>
                      </div>
                      <div className="text-center ps-16 pe-16 pb-16">
                        <div className="border border-gray rounded-5">
                          <div className="row mt-16 ms-16 me-16">
                            <div className="d-flex justify-content-between align-items-center pe-16 pb-0 mb-16 ">
                              <h6 className="mb-0 fs-5">B2B Price Details</h6>
                            </div>
                            <div className="row">
                              <div className="col-md-6 mt-0 pt-0">
                                <h6
                                  htmlFor="b2bDiscountMode"
                                  className="text-md mb-16 fw-bold text-start"
                                >
                                  Discount Mode
                                </h6>
                                <select
                                  id="b2bDiscountMode"
                                  className={`form-select ${
                                    b2bDiscountModeError !== ""
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  value={b2bDiscountMode}
                                  onChange={(e) =>
                                    handleB2bDiscountMode(e.target.value)
                                  }
                                  disabled={!showB2B || readonly}
                                  style={{
                                    borderRadius: "5px",
                                    fontWeight: "400",
                                    outline: "none",
                                    width: "100%",
                                    padding: "11px 24px",
                                    backgroundColor: "transparent !important",
                                    border: "1px solid var(--gray-100)",
                                    color: "hsl(var(--black))",
                                  }}
                                  required
                                >
                                  <option value="">--Select Mode--</option>
                                  <option value="amount">Amount</option>
                                  <option value="percent">Percent</option>
                                </select>
                                <span className="text-danger my-2 small fw-bold">
                                  {b2bDiscountModeError}
                                </span>
                                <br />
                              </div>
                              {/* Selling Price Input */}
                              <div className="col-md-6 mt-0 pt-0">
                                <h6 className="text-md mb-16 fw-bold text-start">
                                  Selling price
                                </h6>
                                <CustomNumberInput
                                  className="form-control"
                                  value={sellingPriceB2BInput}
                                  onChange={handleSellingPriceB2BInput}
                                  disabled={!showB2B || readonly}
                                  style={inputStyle}
                                />
                              </div>
                            </div>
                            <div className="col-md-6 mt-0 pt-0">
                              <h6 className="text-md mb-16 fw-bold text-start">
                                Discount Value
                              </h6>
                              <input
                                type="number"
                                className={`form-control ${
                                  b2bDiscountValueError !== "" &&
                                  "border-danger"
                                }`}
                                value={b2bDiscountValue}
                                readOnly
                                style={{
                                  ...inputStyle,
                                  backgroundColor: "#fff",
                                  cursor: "not-allowed",
                                }}
                              />
                              <span className="text-danger my-2 small fw-bold">
                                {b2bDiscountValueError}
                              </span>
                            </div>
                            <div className="col-md-6 mt-0 pt-0">
                              <h6
                                htmlFor="b2bPriceDifference"
                                className="text-md mb-16 fw-bold text-start"
                              >
                                Price Difference
                              </h6>
                              <select
                                id="b2bPriceDifference"
                                className={`form-select ${
                                  b2bDiscountModeError !== ""
                                    ? "border-danger"
                                    : ""
                                }`}
                                value={b2bPriceDiffMode}
                                onChange={(e) =>
                                  handleB2bPriceDiffMode(e.target.value)
                                }
                                disabled={!showB2B || readonly}
                                style={{
                                  borderRadius: "5px",
                                  fontWeight: "400",
                                  outline: "none",
                                  width: "100%",
                                  padding: "11px 24px",
                                  backgroundColor: "transparent !important",
                                  border: "1px solid var(--gray-100)",
                                  color: "hsl(var(--black))",
                                }}
                                required
                              >
                                <option value="">--Select Mode--</option>
                                <option value="amount">Amount</option>
                                <option value="percent">Percent</option>
                              </select>
                              <span className="text-danger my-2 small fw-bold">
                                {b2bDiscountModeError}
                              </span>
                              <br />
                            </div>
                            <div className="col-md-6 mt-0 pt-0">
                              <h6 className="text-md mb-16 fw-bold text-start">
                                Rate Value
                              </h6>
                              <input
                                type="number"
                                className={`form-control ${
                                  b2bDiscountValueError !== "" &&
                                  "border-danger"
                                }`}
                                value={b2bRateValue}
                                readOnly
                                style={{
                                  ...inputStyle,
                                  backgroundColor: "#fff",
                                  cursor: "not-allowed",
                                }}
                              />
                              <span className="text-danger my-2 small fw-bold">
                                {b2bDiscountValueError}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12 mb-16 ms-16 mt-32">
                          <h6 className="text-md fw-bold text-start">
                            <input
                              type="checkbox"
                              className="me-5"
                              disabled={readonly}
                            />{" "}
                            Include Tax
                          </h6>
                        </div>
                      </div>
                      <div className="text-center ps-16 pe-16 pb-16">
                        <div className="border border-gray rounded-5">
                          <div className="row mt-16 ms-16 me-16">
                            <div className="d-flex justify-content-between align-items-center pe-16 pb-0 mb-16 ">
                              <h6 className="mb-0 fs-5">Tax Details</h6>
                            </div>
                            <div className="col-md-4 mt-0 pt-0">
                              <h6
                                htmlFor="tax"
                                className="text-md mb-16 fw-bold text-start"
                              >
                                Tax (%)
                              </h6>
                              <CustomNumberInput
                                className={`form-control ${
                                  taxError !== "" && "border-danger"
                                }`}
                                placeholder="Enter percentage"
                                id="tax"
                                required
                                onChange={handleTax}
                                value={tax}
                                style={{
                                  bordeRadius: " 5px",
                                  fontWeight: " 400",
                                  outline: " none",
                                  width: " 100%",
                                  padding: " 11px 24px",
                                  backgroundColor: " transparent !important",
                                  border: " 1px solid var(--gray-100)",
                                  color: " hsl(var(--black))",
                                }}
                                disabled={readonly}
                              />
                              <span className="text-danger my-2 small fw-bold">
                                {taxError}
                              </span>
                              <br />
                            </div>
                            <div className="col-md-4 mt-0 pt-0">
                              <h6
                                htmlFor="cgst"
                                className="text-md mb-16 fw-bold text-start"
                              >
                                CGST (%)
                              </h6>
                              <CustomNumberInput
                                className={`form-control ${
                                  cgstError !== "" && "border-danger"
                                }`}
                                placeholder="Enter percentage"
                                id="cgst"
                                required
                                onChange={handleCgst}
                                value={cgst}
                                style={{
                                  bordeRadius: " 5px",
                                  fontWeight: " 400",
                                  outline: " none",
                                  width: " 100%",
                                  padding: " 11px 24px",
                                  backgroundColor: " transparent !important",
                                  border: " 1px solid var(--gray-100)",
                                  color: " hsl(var(--black))",
                                }}
                                disabled={readonly}
                              />
                              <span className="text-danger my-2 small fw-bold">
                                {cgstError}
                              </span>
                              <br />
                            </div>
                            <div className="col-md-4 mt-0 pt-0">
                              <h6
                                htmlFor="sgst"
                                className="text-md mb-16 fw-bold text-start"
                              >
                                SGST (%)
                              </h6>
                              <CustomNumberInput
                                type="number"
                                className={`form-control ${
                                  sgstError !== "" && "border-danger"
                                }`}
                                placeholder="Enter percentage"
                                id="sgst"
                                required
                                onChange={handleSgst}
                                value={sgst}
                                style={{
                                  bordeRadius: " 5px",
                                  fontWeight: " 400",
                                  outline: " none",
                                  width: " 100%",
                                  padding: " 11px 24px",
                                  backgroundColor: " transparent !important",
                                  border: " 1px solid var(--gray-100)",
                                  color: " hsl(var(--black))",
                                }}
                                disabled={readonly}
                              />
                              <span className="text-danger my-2 small fw-bold">
                                {sgstError}
                              </span>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {categoryList.find((cat) => cat.id === category)?.name !==
                  ("Steel" || "Steels") && (
                  <div
                    className="card mb-22 border-0"
                    style={{ height: "auto" }}
                  >
                    <div className="d-flex justify-content-between align-items-center ps-16 pt-16 pe-16 pb-0">
                      <h6 className="mb-0 fs-5">Set Quantity & Price</h6>
                      {!readonly && (
                        <button
                          onClick={clearQuantity}
                          style={{
                            backgroundColor: "#bed9f8ff",
                            color: "#1976d2",
                            border: "none",
                            padding: "8px 20px",
                            fontWeight: "500",
                            borderRadius: "5px",
                          }}
                          disabled={readonly}
                        >
                          Clear
                        </button>
                      )}
                    </div>
                    <div className="row ps-16 pe-16">
                      <div className="col-md-12 mb-16 mt-16">
                        <h6 className="text-md fw-bold text-start">
                          Based on{" "}
                          <label className=" ms-8 me-3">
                            <input
                              type="radio"
                              className="ms-2 me-1"
                              checked={basedOn === "bags"}
                              onChange={() => setBasedOn("bags")}
                              disabled={readonly}
                            />
                            Bags
                          </label>
                          <label>
                            <input
                              type="radio"
                              className="ms-8 me-1"
                              checked={basedOn === "weight"}
                              onChange={() => setBasedOn("weight")}
                              disabled={readonly}
                            />
                            Kg
                          </label>
                          <label>
                            <input
                              type="radio"
                              className="ms-8 me-1"
                              checked={basedOn === "mt"}
                              onChange={() => setBasedOn("mt")}
                              disabled={readonly}
                            />
                            MT
                          </label>{" "}
                          <label>
                            <input
                              type="radio"
                              className="ms-8 me-1"
                              checked={basedOn === "ltr"}
                              onChange={() => setBasedOn("ltr")}
                              disabled={readonly}
                            />
                            Ltr
                          </label>{" "}
                          <label>
                            <input
                              type="radio"
                              className="ms-8 me-1"
                              checked={basedOn === "qty"}
                              onChange={() => setBasedOn("qty")}
                              disabled={readonly}
                            />
                            Qty
                          </label>{" "}
                          <label>
                            <input
                              type="radio"
                              className="ms-8 me-1"
                              checked={basedOn === "unit"}
                              onChange={() => setBasedOn("unit")}
                              disabled={readonly}
                            />
                            Unit
                          </label>
                        </h6>
                      </div>
                    </div>
                    <div className="text-center ps-16 pe-16 pb-16">
                      <div className="border border-gray rounded-5 ">
                        <div className="w-100">
                          {qtyPriceRows.map((row, index) => (
                            <div
                              className="row ms-16 me-16 mt-16 align-items-end pt-8"
                              key={index}
                            >
                              <div className="col-md-11">
                                <div className="row g-2">
                                  <div className="col mt-0 pt-0">
                                    <h6 className="text-md mb-16 fw-bold text-start">
                                      Minimum
                                    </h6>
                                    <CustomNumberInput
                                      className={`form-control ${
                                        qtyPriceErrors[index]?.min &&
                                        "border-danger"
                                      }`}
                                      placeholder={`Enter Minimum ${basedOn === "bags" ? "Bags" : basedOn === "weight" ? "Kg" : basedOn === "mt" ? "MT" : basedOn === "ltr" ? "Ltr" : basedOn === "qty" ? "Qty" : "Unit"}`}
                                      value={row.min}
                                      onChange={(val) =>
                                        handleQtyInputChange(index, "min", val)
                                      }
                                      style={inputStyle}
                                      disabled={readonly}
                                    />
                                    <span className="text-danger my-2 small fw-bold">
                                      {qtyPriceErrors[index]?.min}
                                    </span>
                                  </div>
                                  <div className="col mt-0 pt-0">
                                    <h6 className="text-md mb-16 fw-bold text-start">
                                      Maximum
                                    </h6>
                                    <CustomNumberInput
                                      className={`form-control ${
                                        qtyPriceErrors[index]?.max &&
                                        "border-danger"
                                      }`}
                                      placeholder={`Enter Maximum ${basedOn === "bags" ? "Bags" : basedOn === "weight" ? "Kg" : basedOn === "mt" ? "MT" : basedOn === "ltr" ? "Ltr" : basedOn === "qty" ? "Qty" : "Unit"}`}
                                      value={row.max}
                                      onChange={(val) =>
                                        handleQtyInputChange(index, "max", val)
                                      }
                                      style={inputStyle}
                                      disabled={readonly}
                                    />
                                    <span className="text-danger my-2 small fw-bold">
                                      {qtyPriceErrors[index]?.max}
                                    </span>
                                  </div>
                                  {/* B2C Price */}
                                  <div className="col mt-0 pt-0">
                                    <h6 className="text-md mb-16 fw-bold text-start">
                                      B2C Price
                                    </h6>

                                    <CustomNumberInput
                                      className={`form-control ${
                                        qtyPriceErrors[index]?.setB2cPrice &&
                                        "border-danger"
                                      }`}
                                      placeholder="Enter B2C Price"
                                      value={row.setB2cPrice}
                                      onChange={(val) =>
                                        handleQtyInputChange(
                                          index,
                                          "setB2cPrice",
                                          val,
                                        )
                                      }
                                      style={inputStyle}
                                      disabled={!showB2C || readonly}
                                    />
                                    <span className="text-danger my-2 small fw-bold">
                                      {qtyPriceErrors[index]?.setB2cPrice}
                                    </span>
                                  </div>
                                  {/* B2B Price */}
                                  <div className="col mt-0 pt-0">
                                    <h6 className="text-md mb-16 fw-bold text-start">
                                      B2B Price
                                    </h6>
                                    <CustomNumberInput
                                      className={`form-control ${
                                        qtyPriceErrors[index]?.setB2bPrice &&
                                        "border-danger"
                                      }`}
                                      placeholder="Enter B2B Price"
                                      value={row.setB2bPrice}
                                      onChange={(val) =>
                                        handleQtyInputChange(
                                          index,
                                          "setB2bPrice",
                                          val,
                                        )
                                      }
                                      style={inputStyle}
                                      disabled={!showB2B || readonly}
                                    />
                                    <span className="text-danger my-2 small fw-bold">
                                      {qtyPriceErrors[index]?.setB2bPrice}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-1 d-flex align-items-end p-0 m-0">
                                <div className="d-flex gap-2 mb-40">
                                  {
                                    <MinusCircle
                                      style={{
                                        color: "#1976D2",
                                        background: "#BED9F8",
                                        cursor: "pointer",
                                        fontSize: "18px",
                                        border: "none",
                                        borderRadius: "50%",
                                      }}
                                      onClick={() =>
                                        deleteQtyPriceRow(
                                          index,
                                          qtyPriceRows[index].id,
                                        )
                                      }
                                      disabled={readonly}
                                    />
                                  }
                                  {index === qtyPriceRows.length - 1 && (
                                    <PlusCircle
                                      style={{
                                        color: "#1976D2",
                                        background: "#BED9F8",
                                        cursor: "pointer",
                                        fontSize: "18px",
                                        border: "none",
                                        borderRadius: "50%",
                                      }}
                                      onClick={addQtyPriceRow}
                                      disabled={readonly}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="card mb-22 border-0" style={{ height: "auto" }}>
                  <div className="d-flex justify-content-between align-items-center ps-16 pt-16 pe-16 pb-0">
                    <h6 className="mb-0 fs-5">Product Description</h6>
                    {!readonly && (
                      <button
                        onClick={clearDescription}
                        style={{
                          backgroundColor: "#bed9f8ff",
                          color: "#1976d2",
                          border: "none",
                          padding: "8px 20px",
                          fontWeight: "500",
                          borderRadius: "5px",
                        }}
                        disabled={readonly}
                      >
                        Clear
                      </button>
                    )}
                  </div>
                  <div className="row pt-32 ps-16 pe-16 pb-16">
                    <div>
                      {/* Description Editor */}
                      <Editor
                        editorState={descriptionEditorState}
                        wrapperClassName=""
                        editorClassName="border rounded-5 p-16 lh-lg bg-white"
                        onEditorStateChange={setDescriptionEditorState}
                        placeholder="Your Description Here..."
                        readOnly={readonly}
                        toolbar={{
                          ...(!readonly && {
                            image: {
                              uploadCallback: handleDescriptionImageUpload, // 👈
                              previewImage: true,
                              alt: { present: true, mandatory: false },
                              inputAccept: "image/*",
                            },
                          }),
                        }}
                      />
                    </div>
                    <span className="text-danger my-2 small fw-bold">
                      {descriptionError}
                    </span>
                    <br />
                  </div>
                </div>
                <div className="card mb-22 border-0" style={{ height: "auto" }}>
                  <div className="d-flex justify-content-between align-items-center ps-16 pt-16 pe-16 pb-0">
                    <h6 className="mb-0 fs-5">Product Highlight</h6>
                    {!readonly && (
                      <button
                        onClick={clearHighlight}
                        style={{
                          backgroundColor: "#bed9f8ff",
                          color: "#1976d2",
                          border: "none",
                          padding: "8px 20px",
                          fontWeight: "500",
                          borderRadius: "5px",
                        }}
                        disabled={readonly}
                      >
                        Clear
                      </button>
                    )}
                  </div>
                  <div className="row pt-32 ps-16 pe-16 pb-16">
                    <div>
                      <Editor
                        editorState={highlightEditorState}
                        wrapperClassName=""
                        editorClassName="border rounded-5 p-16 lh-lg bg-white"
                        onEditorStateChange={setHighlightEditorState}
                        placeholder="Your Highlight Here..."
                        readOnly={readonly}
                        toolbar={{
                          ...(!readonly && {
                            image: {
                              uploadCallback: handleHighlightImageUpload,
                              previewImage: true,
                              alt: { present: true, mandatory: false },
                              inputAccept: "image/*",
                            },
                          }),
                        }}
                      />
                    </div>
                    <span className="text-danger my-2 small fw-bold">
                      {highlightError}
                    </span>
                    <br />
                  </div>
                </div>
                <div className="card mb-22 border-0" style={{ height: "auto" }}>
                  <div className="d-flex justify-content-between align-items-center ps-16 pt-16 pe-16 pb-0">
                    <h6 className="mb-0 fs-5">Specification</h6>
                    {!readonly && (
                      <button
                        onClick={clearSpecification}
                        style={{
                          backgroundColor: "#bed9f8ff",
                          color: "#1976d2",
                          border: "none",
                          padding: "8px 20px",
                          fontWeight: "500",
                          borderRadius: "5px",
                        }}
                        disabled={readonly}
                      >
                        Clear
                      </button>
                    )}
                  </div>
                  <div className="row text-center ps-16 pe-16 pb-16">
                    {specGroups.length === 0 ? (
                      <p className="text-muted">
                        No specifications defined for this category.
                      </p>
                    ) : (
                      getMergedSpecGroups().map((group, idx) => (
                        <div className="col-12 mb-4" key={idx}>
                          <h6 className="text-md fw-bold text-start mt-8">
                            {group.groupName}
                          </h6>
                          <div className="border rounded-5 text-center ps-26 pe-16 pb-16 pt-16">
                            {group.specs.map((spec) => {
                              // Parse options safely (handle string or array)
                              let optionsList = [];
                              if (Array.isArray(spec.options)) {
                                optionsList = spec.options;
                              } else if (typeof spec.options === "string") {
                                optionsList = spec.options
                                  .split(",")
                                  .map((opt) => opt.trim())
                                  .filter(Boolean);
                              }

                              return (
                                <div
                                  className="row mb-3 align-items-start"
                                  key={spec.id}
                                >
                                  <div className="col-md-6 text-start border border-gray rounded-5 p-13">
                                    <h6 className="fs-6 mb-0">{spec.title}</h6>
                                  </div>
                                  <div className="col-md-6">
                                    {spec.fieldType === "TEXT" ||
                                    !spec.fieldType ? (
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={specValues[spec.id] || ""}
                                        onChange={(e) =>
                                          handleSpecValueChange(
                                            spec.id,
                                            e.target.value,
                                          )
                                        }
                                        placeholder={`Enter ${spec.title}`}
                                        style={inputStyle}
                                        disabled={readonly}
                                      />
                                    ) : spec.fieldType === "DROPDOWN LIST" ? (
                                      <select
                                        className="form-select"
                                        value={specValues[spec.id] || ""}
                                        onChange={(e) =>
                                          handleSpecValueChange(
                                            spec.id,
                                            e.target.value,
                                          )
                                        }
                                        style={inputStyle}
                                        disabled={readonly}
                                      >
                                        <option value="" disabled={readonly}>
                                          --Select--
                                        </option>
                                        {optionsList.map((option) => (
                                          <option key={option} value={option}>
                                            {option}
                                          </option>
                                        ))}
                                      </select>
                                    ) : spec.fieldType === "RADIO BUTTON" ? (
                                      <div className="d-flex flex-wrap gap-5 border border-gray rounded-5 p-10">
                                        {optionsList.map((option) => (
                                          <div
                                            key={option}
                                            className="form-check"
                                          >
                                            <input
                                              className="form-check-input"
                                              type="radio"
                                              name={`spec-${spec.id}`}
                                              id={`radio-${spec.id}-${option}`}
                                              value={option}
                                              checked={
                                                specValues[spec.id] === option
                                              }
                                              onChange={(e) =>
                                                handleSpecValueChange(
                                                  spec.id,
                                                  e.target.value,
                                                )
                                              }
                                              disabled={readonly}
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor={`radio-${spec.id}-${option}`}
                                            >
                                              {option}
                                            </label>
                                          </div>
                                        ))}
                                      </div>
                                    ) : spec.fieldType === "CHECKBOX" ? (
                                      <div className="d-flex flex-wrap gap-5 border border-gray rounded-5 p-10">
                                        {optionsList.map((option) => (
                                          <div
                                            key={option}
                                            className="form-check"
                                          >
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id={`checkbox-${spec.id}-${option}`}
                                              checked={(
                                                specValues[spec.id] || []
                                              ).includes(option)}
                                              onChange={(e) => {
                                                const current =
                                                  specValues[spec.id] || [];
                                                const updated = e.target.checked
                                                  ? [...current, option]
                                                  : current.filter(
                                                      (val) => val !== option,
                                                    );
                                                handleSpecValueChange(
                                                  spec.id,
                                                  updated,
                                                );
                                              }}
                                              disabled={readonly}
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor={`checkbox-${spec.id}-${option}`}
                                            >
                                              {option}
                                            </label>
                                          </div>
                                        ))}
                                      </div>
                                    ) : (
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={specValues[spec.id] || ""}
                                        onChange={(e) =>
                                          handleSpecValueChange(
                                            spec.id,
                                            e.target.value,
                                          )
                                        }
                                        placeholder={`Enter ${spec.title}`}
                                        style={inputStyle}
                                        disabled={readonly}
                                      />
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="py-3 d-flex justify-content-between align-items-end">
              <div></div>
              <div className="d-flex">
                {saving || saveExtraImagesLoading || saveMainImageLoading ? (
                  <>
                    {!readonly && (
                      <button
                        style={{
                          height: "40px",
                          width: "110px",
                          color: "white",
                          backgroundColor: "#2696D5",
                          border: "none",
                          borderRadius: "6px",
                          marginRight: "10px",
                        }}
                        onClick={(e) => e.preventDefault()}
                      >
                        {type === EDIT ? "Update" : "Add"}
                      </button>
                    )}
                  </>
                ) : (
                  <>
                    {!readonly && (
                      <button
                        style={{
                          height: "40px",
                          width: "110px",
                          color: "white",
                          backgroundColor: "#2696D5",
                          border: "none",
                          borderRadius: "6px",
                          marginRight: "10px",
                        }}
                        onClick={(e) => preventClick(e, handleSave)}
                      >
                        {type === EDIT ? "Update" : "Add"}
                      </button>
                    )}
                  </>
                )}
                {!readonly && (
                  <button
                    style={{
                      backgroundColor: "#bed9f8ff",
                      color: "#1976d2",
                      border: "none",
                      padding: "8px 20px",
                      fontWeight: "500",
                      borderRadius: "5px",
                    }}
                    onClick={clearFields}
                    disabled={readonly}
                  >
                    Clear All
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

const ExtraImage = ({ src, onClose, readOnly }) => (
  <div className="col-6 col-sm-4 col-md-3 col-lg-2 mb-0 text-center position-relative">
    <img
      src={src.imageUrl || src}
      alt=""
      className="p-0"
      style={{
        height: "200px",
        width: "100%",
        objectFit: "contain",
        background: "#fff",
      }}
    />
    <div
      className="position-absolute start-50 translate-middle-x"
      style={{ bottom: "10px", zIndex: 2 }}
    >
      <div
        className="bg-danger cursor-pointer rounded"
        style={{ width: "20px", height: "20px", marginTop: "-45px" }}
        onClick={() => onClose()}
        readOnly={readOnly}
      >
        <i className="fas fa-times text-white"></i>
      </div>
    </div>
  </div>
);
const Category = ({ index, name, onSelect, isSelected, readOnly }) => (
  <div className="col-12 col-sm-5 col-md-5 col-lg-3 mb-3">
    <label
      className={`d-flex align-items-center cursor-pointer`}
      htmlFor={"category" + index}
    >
      {/* Radio Input */}
      <input
        type="radio"
        name="category"
        id={"category" + index}
        className="form-check-input me-5"
        checked={isSelected}
        onChange={onSelect}
        disabled={readOnly}
      />
      {/* Label Text */}
      <span>{name}</span>
    </label>
  </div>
);
export default ProductForm;
